import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Image,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Animated as ReactAnimated,
  Dimensions,
  Switch,
  Modal,
  InputAccessoryView,
  Keyboard,
} from 'react-native';
import Animated, {
  Easing,
  measure,
  runOnUI,
  useAnimatedRef,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import 'react-native-reanimated';
import { createStackNavigator } from '@react-navigation/stack';
import { addHours, format, isAfter, isBefore, parseISO } from 'date-fns';
import { isTablet } from 'react-native-device-info';
import { EventRegister } from 'react-native-event-listeners';
import Toast, { useToast } from 'react-native-toast-notifications';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import HTML from 'react-native-render-html';
import ModalWeb from 'react-native-modal';
import MenuComponent from '../../components/MenuComponent';
import AppContext from '../../navigation/Context';
import * as MenuNavigation from '../../navigation/MenuNavigation';
import colors from '../../resources/colors';
import images from '../../resources/images';
import bibleHTML from '../../resources/bibleHTML';
import DataController from '../../controllers/DataController';
import FirebaseService from '../../controllers/FirebaseService';
import renderers from '../../resources/renderers';
import ReadModal from '../../components/ReadModal';
import Popover, { PopoverPlacement } from 'react-native-popover-view';
import Collapsible from 'react-native-collapsible';
import Clipboard from '@react-native-clipboard/clipboard';
import clipboard from 'clipboard';
import { CommonActions, useFocusEffect, useNavigationState } from '@react-navigation/native';
import * as RootNavigation from '../../navigation/RootNavigation';
import SundayWorshipModal from '../../components/SundayWorshipModal';
import PewSheetModal from '../../components/PewSheetModal';
import GenerateServiceSheetModal from '../../components/GenerateServiceSheetModal';
import { WebView } from 'react-native-webview';
import SegmentedControl from '@react-native-segmented-control/segmented-control';
import DropDownPicker from 'react-native-dropdown-picker';
import DatabaseService from '../../controllers/DatabaseController';
import * as FileSystem from 'expo-file-system';
import { Asset } from 'expo-asset';
import RNFS from 'react-native-fs';
import NoAccessModal from '../../components/NoAccessModal';
import AuthenticationController from '../../controllers/AuthenticationController';
import NetInfo from '@react-native-community/netinfo';
import IAPController from '../../controllers/IAPController';
import Share from 'react-native-share';
import RNCalendarEvents from "react-native-calendar-events";

const AnimatedKeyboardAwareScrollView = Animated.createAnimatedComponent(KeyboardAwareScrollView);

let checkAccessInterval;

let tagsStyles = {
  p: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 22,
    letterSpacing: -0.1,
    color: colors.defaultText,
  },
  red: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.defaultText,
  },
  strong: {
    fontFamily: 'FiraSans-SemiBoldItalic',
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
  },
  a: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: -0.1,
    color: colors.defaultText,
    textDecorationLine: 'underline',
  },
  i: {
    fontFamily: 'FiraSans-Italic',
    fontWeight: 'normal',
    fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
    color: colors.defaultText,
  },
  strong: {

  },
  b: {
    fontFamily: 'FiraSans-Bold',
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
  },
  h1: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginTop: 16,
    marginBottom: 8,
  },
  h2: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginTop: 16,
    marginBottom: 8,
  },
  tab: {
    fontFamily: 'FiraSans-Regular',
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: -0.1,
    color: colors.defaultText,
  },
  line: {
    marginBottom: 10,
  }
};

let classesStyles = {
  eventReadingsContainer: {
    backgroundColor: colors.primary,
  },
  a2: {
    fontFamily: 'FiraSans-Regular',
    // fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    // lineHeight: 20,
    letterSpacing: -0.1,
    color: colors.red,
    textDecorationLine: 'underline',
    marginBottom: 0,
  },
  biog: {
    marginTop: 8,
  },
  AdditionalLectionary: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 26,
    letterSpacing: -0.1,
    color: colors.primary,
    // marginBottom: 4,
  },
  'plus-S': {
    display: 'none',
  },
  eventReadingHeader: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 18,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.accentBlack,
    overflow: 'visible',
    marginBottom: 16,
  },
  passageref: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 28,
    letterSpacing: -0.1,
    color: colors.primary,
    margin: 0,
  },
  rightRed: {
    fontFamily: 'FiraSans-SemiBoldItalic',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.red,
    textAlign: 'right',
  }
}

const modalStyles = StyleSheet.create({
  tabletModal: {
    alignItems: undefined,
    justifyContent: undefined,
    width: Platform.OS === 'web' ? '100%' : Dimensions.get('window').width,
    height: Platform.OS === 'web' ? null : Dimensions.get('window').height,
    overflow: 'hidden',
    borderRadius: Platform.OS === 'web' ? 0 : 10,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    alignSelf: 'center',
    top: Platform.OS === 'web' ? 0 : 25,
    margin: 0,
  },
  height: {
    height: Dimensions.get('window').height,
  },
});

const ServiceSheetButton = ({ handlePress }) => (
  <Button
    label="View Service Sheet"
    // eslint-disable-next-line react-native/no-inline-styles
    buttonStyle={{
      backgroundColor: colors.grey30,
      borderWidth: 1,
      borderColor: colors.primary,
      height: 30,
      borderRadius: 8,
      width: 153,
      minWidth: 153,
    }}
    textStyle={{ color: colors.primary }}
    iconColor={{ tintColor: colors.primary }}
    handlePress={handlePress}
    showDisclosure={false}
  />
);

const FullServiceButton = ({ handlePress }) => (
  <Button
    label="View Full Service"
    // eslint-disable-next-line react-native/no-inline-styles
    buttonStyle={{
      backgroundColor: colors.grey30,
      borderWidth: 1,
      borderColor: colors.primary,
      height: 30,
      borderRadius: 8,
      width: 139,
    }}
    textStyle={{ color: colors.primary }}
    iconColor={{ tintColor: colors.primary }}
    handlePress={handlePress}
    showDisclosure={false}
  />
);

const Button = ({ label, onPress, buttonStyle, textStyle, iconColor, handlePress, showDisclosure }) => {
  return (
    <TouchableOpacity
      style={[styles.serviceButton, buttonStyle]}
      activeOpacity={0.5}
      onPress={handlePress}>
      <Text style={[styles.buttonText, textStyle]} allowFontScaling={false} numberOfLines={1}>
        {label}
      </Text>
      {showDisclosure ?
        <Image
          style={[styles.buttonDisclosure, iconColor]}
          source={images.Button_Disclosure_Right_White}
        />
        : null}
    </TouchableOpacity>
  );
};

const Header = ({ day, fontMultiplier }) => {
  let background =
    day.Colour && (day.Colour === 'Hangings removed' ? 'grey' : day.Colour.split(' ')[0].toLowerCase());
  const backgroundHex = DataController.colourNameToHex(background);
  const textColor = backgroundHex ? DataController.getTextColor(backgroundHex) : colors.accentWhite;

  const time = new Date(new Date(day.Date).valueOf());

  return (
    <View style={styles.header}>
      {/* <View style={styles.headerContainer}>
        <Image
          style={styles.headerIcon}
          source={images.Icon_Lectionary_Active}
          resizeMode="cover"
        />
        <Text style={styles.headerTitle} allowFontScaling={false}>
          {'Lectionary'}
        </Text>
      </View>
      <View style={styles.headerSeparator} /> */}
      <View style={styles.serviceContainer}>
        <View style={{ maxWidth: Dimensions.get('window').width > 800 ? '100%' : '60%', }}>
          <Text
            style={[styles.weekTitle, {
              fontSize: 12 * fontMultiplier,
              lineHeight: 16 * fontMultiplier,
            }]}
            allowFontScaling={false}>
            {day.WeekTitle}
          </Text>
          <Text
            style={[styles.date, {
              fontSize: 20 * fontMultiplier,
              lineHeight: 28 * fontMultiplier,
            }]}
            allowFontScaling={false}>
            {format(parseISO(day.Date), 'EEEE d MMMM yyyy')}
          </Text>
          {day.DayTitle && (
            <Text
              style={[styles.dayTitle, {
                fontSize: 15 * fontMultiplier,
                lineHeight: 20 * fontMultiplier,
              }]}
              allowFontScaling={false}>
              {day.DayTitle}
            </Text>
          )}
        </View>
        {day.Colour && (
          <View
            style={[
              styles.colorContainer,
              {
                height: day.Colour === 'White' ? 18 : 16,
                backgroundColor: backgroundHex ? backgroundHex : 'grey',
                borderWidth: day.Colour === 'White' ? 1 : 0,
              },
            ]}>
            <Text style={[styles.colorText, { color: textColor }]} allowFontScaling={false}>
              {day.Colour}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const Reading = ({ day, reading, fontMultiplier }) => {
  const toast = useToast();
  const toastRef = useRef();

  const [modalVisible, setModalVisible] = useState(false);
  const [bibleReading, setBibleReading] = useState(null);

  const readingTagsStyles = {
    p: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 0,
    },
    i: {
      fontFamily: 'FiraSans-Italic',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
    b: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
    a: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
  };

  const readingTags = {
    h2: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      marginTop: 16,
      marginBottom: 8,
    },
    p: {
      marginBottom: 8,
      margin: 0,
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
    i: {
      fontFamily: 'FiraSans-Italic',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
  };

  const readingClassStyles = {
    passageref: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    pn: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    bibletext: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
    MsoNormal: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
      marginBottom: 0,
    },
    vv: {
      fontFamily: 'FiraSans-SemiBold',
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    },
    ww: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      // lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginHorizontal: 3,
      bottom: 0,
    },
    uu: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginEnd: 3,
      bottom: 0,
    },
    cc: {
      fontSize: 20 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
      marginEnd: 3,
    },
    'plus-S': classesStyles['plus-S'],
    'plus-Z': classesStyles['plus-S'],
    'plus-C': classesStyles['plus-S'],
    'plus-B': classesStyles['plus-S'],
    'plus-FT': classesStyles['plus-S'],
    fnote: classesStyles['plus-S'],
    redlight: {
      fontSize: 24 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
    }
  };

  // const html = reading.data.replace(/<a/gm, '<p').replace(/<\/a>/gm, '</p>');

  const onLinkPress = async (event, href) => {
    const ref = href.replace('BibleRef/', '').replace('.html', '');
    const file = bibleHTML[`${ref}`];

    __DEV__ && console.log(ref);
    __DEV__ && console.log(file);

    try {
      let uri;
      let html;

      if (Platform.OS === 'web') {
        html = file;

        html = html
          .replace(/<p>\s+<\/p>/gim, '')
          .replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
          .replace(/<AF>.*<\/AF>/gm, '');

        setBibleReading(html);
      } else {
        uri = Image.resolveAssetSource(file).uri;

        if (__DEV__) {
          html = await fetch(uri);
          html = await html.text();
        } else if (Platform.OS === 'ios') {
          // Release version - don't decode uri
          html = await RNFS.readFile(uri, 'utf8');
          // Debug version - need to decode uri
          // html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
        } else if (Platform.OS === 'android') {
          html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
          // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
        }
      }

      html = html.replace(/<h2 class="(?!passageref|pn).+">(.*?)<\/h2>/gm, '');

      html = html
        .replace(/<p>\s+<\/p>/gim, '')
        .replace(/<!--[\s\S]*?-->/gm, '')
        .replace(/&nbsp;/gm, ' ')
        // .replace(/<div class="bibletext">\n<p>/gm, '<div class="bibletext">\n')
        .replace('<p>', '')
        .replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
        .replace(/<span class="\w+">\d+<\/span>(?!&nbsp;)/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<sup class="\w+">\d+<\/sup>(?!&nbsp;)/gim, function (match, token) {
          return ` ${match} `;
        })
        .replace(/<br class=kk \/>/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<h2 class="passageref">(.*?)<\/h2>/gm, function (match, token) {
          return match.replace(/\[|\]/gm, '');
        })
        .replace(/<h2 class="pn">(.*?)<\/h2>/gm, function (match, token) {
          return `<b>${match}</b><br>`;
        })
        .replace(/<h2 class="pn"/gim, `<h2 style="font-family=FiraSans-SemiBold;font-size:${20 * fontMultiplier}px;font-weight:600;line-height:${26 * fontMultiplier}px;letter-spacing:-0.1px;color:${colors.primary};"`)
        .replace(/class="redlight"/gim, "style='color:#880f30;font-size:20px;font-weight: normal;'")
        .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
        .replace(/<AF>.*<\/AF>/gm, '');

      __DEV__ && console.log(html);

      setBibleReading(`${html}</div>`);
    } catch (error) {
      console.log(error);
      setBibleReading('Unable to load bible file');
    }

    setModalVisible(true);
  };

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Service Sheet' });

    let plaintext = bibleReading;
    let richtext = `<div style="font-size: 1em;">${bibleReading}</div>`;

    plaintext = DataController.formatHTMLToPlaintext(plaintext);
    plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    toastRef.current.show('Reading copied', { id: Date.now(), });
  };

  const closeModal = () => setModalVisible(false);

  __DEV__ && console.log(reading);

  return (
    <View style={styles.readingContainer}>
      <ReadModal visible={modalVisible} closeModal={closeModal}>
        <View style={[styles.modalHeader, {
          borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
          borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
        }]}>
          <TouchableOpacity onPress={() => setModalVisible(false)}>
            <Image style={styles.menuIcon} source={images.Button_Close} />
          </TouchableOpacity>
          <View style={styles.modalHeaderRight}>
            <TouchableOpacity style={styles.buttonPadding} onPress={copyPressed}>
              <Image style={styles.menuIcon} source={images.Button_Copy} />
            </TouchableOpacity>
          </View>
        </View>
        <Toast ref={toastRef} style={{ marginBottom: 40 }} offsetBottom={60} />
        <ScrollView
          style={{
            flex: 1,
            height: '100%',
            width: '100%',
            backgroundColor: colors.accentWhite,
            paddingBottom: 100,
          }}
          indicatorStyle="black"
          contentContainerStyle={styles.bibleScrollViewContainer}>
          <HTML
            ignoredStyles={[
              ...(bibleReading && bibleReading.includes('MsoNormal') ? ['font-family'] : []),
              'margin-left',
              'margin-right',
            ]}
            source={{ html: bibleReading ? bibleReading : '<div></div>' }}
            tagsStyles={readingTags}
            classesStyles={readingClassStyles}
            renderers={renderers}
            renderersProps={{
              fontMultiplier,
            }}
            containerStyle={{
              width: '100%'
            }}
            baseFontStyle={{
              margin: 0,
              fontFamily: 'FiraSans-SemiBold',
              fontSize: 17 * fontMultiplier,
              fontWeight: '600',
              fontStyle: 'normal',
              lineHeight: 28 * fontMultiplier,
              letterSpacing: -0.06,
              color: colors.defaultText,
              marginBottom: 0,
            }}
            defaultTextProps={{
              selectable: true,
            }}
          />
        </ScrollView>
      </ReadModal>
      <View style={[styles.optionButton, { marginBottom: 16 }]}>
        {/* {reading.option.includes('Prayer') ?
          <Image
            source={images.Icon_DP_Active}
          />
          : null}
        */}
        {day.DayOfWeek === 'Sunday' && reading.option.includes('Principal Service') ?
          <Image
            style={{
              height: 44,
              width: 44,
              marginStart: -6.5,
            }}
            source={images.Icon_SW_Active}
          />
          : null}
        <Text
          style={[styles.optionText, {
            fontSize: 15 * fontMultiplier,
            lineHeight: 20 * fontMultiplier,
          }]}>
          {reading.option}
        </Text>
      </View>
      <HTML
        ignoredStyles={['font-family']}
        tagsStyles={tagsStyles}
        renderersProps={{
          fontMultiplier,
        }}
        renderers={renderers}
        source={{ html: reading && reading.data.replace(/<i>or<\/i>/gim, '<i> or</i>').replace(/<\/i>/gim, ' </i>').replace(/<line><line>/gm, '<line>').replace(/<img (.*?)\/>/gm, '') }}
        onLinkPress={(event, href) => onLinkPress(event, href)}
        baseFontStyle={{
          flex: 0,
          fontFamily: 'FiraSans-Regular',
          fontSize: 15 * fontMultiplier,
          fontWeight: 'normal',
          fontStyle: 'normal',
          lineHeight: 20 * fontMultiplier,
          letterSpacing: -0.1,
          color: colors.defaultText,
          // textDecorationLine: 'underline',
        }}
        defaultTextProps={{
          selectable: true,
        }}
      />
    </View>
  );
};

const Readings = ({ readings, notes, day, fontMultiplier, serviceType }) => {
  const toast = useToast();
  const toastRef = useRef();

  const churchNameRef = useRef(null);
  const introductionRef = useRef(null);
  const footerRef = useRef(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [swModalVisible, setSWModalVisible] = useState(false);
  const [bibleReading, setBibleReading] = useState(null);
  const [generateModalVisible, setGenerateModalVisible] = useState(false);
  const [pewSheetModalVisible, setPewSheetModalVisible] = useState(false);
  const [sundayWorshipData, setSundayWorshipData] = useState('');
  const [showService, setShowService] = useState(false);
  const [serviceContents, setServiceContents] = useState(false);
  const [churchName, setChurchName] = useState('');
  const [introduction, setIntroduction] = useState('');
  const [footer, setFooter] = useState('');

  useEffect(() => {
    EventRegister.addEventListener('modal/open-service-sheet', () => setSWModalVisible(true));

    return () => EventRegister.removeEventListener('modal/open-service-sheet');
  });

  useEffect(() => {
    const loadInputs = async () => {
      let info = await DataController.getChurchInformation();

      if (info) {
        setChurchName(info.churchName);
        setIntroduction(info.introduction);
        setFooter(info.footer);
      }
    };

    const focusChurchName = () => {
      if (generateModalVisible) {
        churchNameRef.current?.focus();
      }
    };

    loadInputs();
    focusChurchName();
  }, [generateModalVisible])

  const showToast = (text) => {
    toast.show(text, { id: 'text' });
  };

  const readingTagsStyles = {
    p: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 0,
    },
    b: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
    a: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
  };

  const readingTags = {
    h2: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      marginTop: 16,
      marginBottom: 8,
    },
    p: {
      margin: 0,
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 22 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginVertical: 2,
    },
    i: {
      fontFamily: 'FiraSans-Italic',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 22 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
  };

  const readingClassStyles = {
    passageref: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    pn: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    bibletext: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
    MsoNormal: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 0,
    },
    ww: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginHorizontal: 3,
      bottom: 0,
    },
    uu: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginEnd: 3,
      bottom: 0,
    },
    cc: {
      fontSize: 20 * fontMultiplier,
      lineHeight: 24 * fontMultiplier,
      marginEnd: 3,
    },
    'plus-S': classesStyles['plus-S'],
    'plus-Z': classesStyles['plus-S'],
    'plus-C': classesStyles['plus-S'],
    'plus-B': classesStyles['plus-S'],
    'plus-FT': classesStyles['plus-S'],
    fnote: classesStyles['plus-S'],
    redlight: {
      fontSize: 24 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
    },
    eventReadingHeader: classesStyles.eventReadingHeader,
    WOLDiv: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    bibletext: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    boldRight: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.defaultText,
      textAlign: 'right',
      marginTop: 8,
    },
    bibleReadingTitle: {
      fontFamily: 'FiraSans-SemiBoldItalic',
      fontSize: 17 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.defaultText,
      textAlign: 'right',
      marginTop: 8,
    },
    bibleReadingTitleRed: {
      fontFamily: 'FiraSans-SemiBoldItalic',
      fontSize: 17 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.red,
      textAlign: 'right',
      marginTop: 8,
      marginBottom: 8,
    },
    rightRed: {
      fontFamily: 'FiraSans-SemiBoldItalic',
      fontSize: 17 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.red,
      textAlign: 'right',
      marginTop: 8,
    },
    collectOr: {
      fontFamily: 'FiraSans-SemiBoldItalic',
      fontSize: 17 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.red,
      marginVertical: 4,
    },
    WOL: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginTop: 8,
      paddingStart: 14 * fontMultiplier,
    },
    TBTG: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 16 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    TBTGSpanAll: {
      fontFamily: 'FiraSans-Italic',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.red,
    },
    TBTGSpan2: {
      marginStart: 5 * fontMultiplier,
    }
  };

  useEffect(() => {
    const isGospel = (verseObject) => {
      if (verseObject.Gospel === 'Matthew' ||
        verseObject.Gospel === 'Mark' ||
        verseObject.Gospel === 'Luke' ||
        verseObject.Gospel === 'John') {
        return true;
      }

      return false;
    };

    const isNewTestament = (verseObject) => {
      let newTestamentsBook = [
        "Matthew",
        "Mark",
        "Luke",
        "John",
        "Acts (of the Apostles)",
        "Romans",
        "1 Corinthians",
        "2 Corinthians",
        "Galatians",
        "Ephesians",
        "Philippians",
        "Colossians",
        "1 Thessalonians",
        "2 Thessalonians",
        "1 Timothy",
        "2 Timothy",
        "Titus",
        "Philemon",
        "Hebrews",
        "James",
        "1 Peter",
        "2 Peter",
        "1 John",
        "2 John",
        "3 John",
        "Jude",
        "Revelation"
      ];

      if (newTestamentsBook.indexOf(verseObject.Gospel) !== -1) {
        return true;
      }

      return false;
    };

    const aRefToVerseObj = (ref) => {
      let href = ref.split('href="BibleRef/')[1];

      // __DEV__ && console.log(ref);

      if (href === undefined) {
        return null;
      }

      href = href.substring(0, href.indexOf('>') - 6);

      let book = href.substring(0, href.indexOf('%'));

      const object = {
        FileName: href,
        verseRef: ref.replace(/<[^>]*>?/gm, ''),
        Gospel: book,
      };

      return object;
    };

    const pushVerse = (array, object) => {
      let index = DataController.indexOfVerseObject(array, object);

      if (index === -1) {
        array.push(object);
      }

      return array;
    };

    const generateServiceSheet = async () => {
      try {
        if (day.DayOfWeek === 'Sunday' || (day.Readings[0] && day.Readings[0].option.includes('Principal Service'))) {
          let collects = day.Collect;
          let collectHTML = '';
          let PostCommunionPrayer = day['Post Communion prayer'];
          let PostCommunionPrayerHTML = '';
          let readings = day.Readings;
          let continuousReadings = [];
          let relatedReadings = [];
          let otherReadings = [];
          let gospelReadings = [];
          let HTML = '';

          if (collects) {
            collectHTML += '<div class="rightRed">Collect</div>';

            for (let i = 0; i < collects.length; i++) {
              let collect = collects[i];
              collectHTML += collect.data;

              if (i < collects.length - 1) {
                collectHTML += '<div class="collectOr">or</div>';
              }
            }

            HTML += collectHTML;
          }

          if (readings) {
            HTML += '<div class="boldRight">Readings</div>';

            for (let i = 0; i < readings.length; i++) {
              let reading = readings[i];

              __DEV__ && console.log(reading);

              if (reading.option === 'Principal Service' ||
                reading.option === 'Vigil Readings' ||
                reading.option === 'Complementary Psalmody' ||
                reading.option === 'Holy Communion') {
                let readingText = reading.data;
                let refs = readingText.match(/<line\b[^>]*>(.*?)<\/line>/gm);
                let refsAnchor = readingText.match(/<a\b[^>]*>(.*?)<\/a>/gm);
                let refsEscaped = refs.map((ref) => ref.replace(/<[^>]*>?/gm, ''));

                let continuousIndex = refs.findIndex((ref) => ref.includes('Continuous:'));
                let refsIndex = refs.findIndex((ref) => ref.includes('Related:'));

                __DEV__ && console.log(continuousIndex, refsIndex);
                // console.log(reading.data, refs);

                if (readingText.includes('Continuous:')) {
                  let continuousRefs = refs.slice(continuousIndex + 1, refsIndex);

                  for (let j = 0; j < continuousRefs.length; j++) {
                    let verseObject = aRefToVerseObj(continuousRefs[j]);

                    if (verseObject && !isGospel(verseObject) && !isNewTestament(verseObject)) {
                      continuousReadings = pushVerse(continuousReadings, verseObject);
                    }
                  }
                }

                if (readingText.includes('Related:')) {
                  let relatedRefs = refs.slice(refsIndex + 1);

                  for (let j = 0; j < relatedRefs.length; j++) {
                    let verseObject = aRefToVerseObj(relatedRefs[j]);

                    if (verseObject && !isGospel(verseObject) && !isNewTestament(verseObject)) {
                      relatedReadings = pushVerse(relatedReadings, verseObject);
                    }
                  }
                }

                for (let j = 0; j < refsAnchor.length; j++) {
                  let verseObject = aRefToVerseObj(refsAnchor[j]);

                  if (verseObject) {
                    if (isGospel(verseObject)) {
                      gospelReadings = pushVerse(gospelReadings, verseObject);
                    } else {
                      if (continuousReadings.length === 0 || isNewTestament(verseObject)) {
                        otherReadings = pushVerse(otherReadings, verseObject);
                      }
                    }
                  }
                }
              }
            }

            if (serviceType === 'continuous' && continuousReadings.length > 0) {
              HTML += '<div class="bibleReadingTitle">Continuous:</div>';

              for (let i = 0; i < continuousReadings.length; i++) {
                let reading = continuousReadings[i];

                HTML += `<div class="bibleReadingTitleRed">${reading.verseRef}</div>`;

                const file = bibleHTML[`${reading.FileName}`];

                HTML += await DataController.getBibleHTMLFromFile(file, true);

                if (reading.Gospel !== 'Psalm') {
                  HTML += `<div class="WOLDiv"><div class='WOL'>This is the word of the Lord.</div><div class='TBTG'><span class=TBTGSpanAll>All</span><span class=TBTGSpan2> Thanks be to God.</span></div></div>\n\n`;
                }
              }
            }

            if (serviceType === 'related' && relatedReadings.length > 0) {
              HTML += '<div class="bibleReadingTitle">Related:</div>';

              for (let i = 0; i < relatedReadings.length; i++) {
                let reading = relatedReadings[i];

                let verseRef = reading.verseRef.replace(/\[|\]/gm, '');

                HTML += `<div class="bibleReadingTitleRed">${verseRef}</div>`

                const file = bibleHTML[`${reading.FileName}`];

                HTML += await DataController.getBibleHTMLFromFile(file, true);

                if (reading.Gospel !== 'Psalm') {
                  HTML += `<div class="WOLDiv"><div class='WOL'>This is the word of the Lord.</div><div class='TBTG'><span class=TBTGSpanAll>All</span><span class=TBTGSpan2> Thanks be to God.</span></div></div>\n\n`;
                }

              }
            }

            if (otherReadings.length > 0) {
              if (relatedReadings.length > 0) {
                HTML += '<div class="boldRight">New Testament Reading</div>';
              }

              for (let i = 0; i < otherReadings.length; i++) {
                let reading = otherReadings[i];

                let verseRef = reading.verseRef.replace(/\[|\]/gm, '');

                HTML += `<div class="bibleReadingTitleRed">${verseRef}</div>`

                const file = bibleHTML[`${reading.FileName}`];

                HTML += await DataController.getBibleHTMLFromFile(file, true);

                if (reading.Gospel !== 'Psalm') {
                  HTML += `<div class="WOLDiv"><div class='WOL'>This is the word of the Lord.</div><div class='TBTG'><span class=TBTGSpanAll>All</span><span class=TBTGSpan2> Thanks be to God.</span></div></div>\n\n`;
                }
              }
            }

            if (gospelReadings.length > 0) {
              HTML += '<div class="boldRight">Gospel Reading</div>';

              for (let i = 0; i < gospelReadings.length; i++) {
                let reading = gospelReadings[i];

                HTML += `<div class="WOLDiv"><div class='WOL'>Hear the Gospel of our Lord Jesus Christ according to ${reading.Gospel}.</div><div class='TBTG'><span class=TBTGSpanAll>All</span><span class=TBTGSpan2> Glory to you, O Lord.</span></div></div>\n\n`;

                let verseRef = reading.verseRef.replace(/\[|\]/gm, '');

                HTML += `<div class="bibleReadingTitleRed">${verseRef}</div>`

                const file = bibleHTML[`${reading.FileName}`];

                HTML += await DataController.getBibleHTMLFromFile(file, true);

                HTML += `<div class="WOLDiv"><div class='WOL'>This is the Gospel of the Lord.</div><div class='TBTG'><span class=TBTGSpanAll>All</span><span class=TBTGSpan2> Praise to you, O Christ.</span></div></div>\n\n`;
              }
            }
          }

          if (PostCommunionPrayer) {
            PostCommunionPrayerHTML += '<div class="rightRed">Post Communion</div>';

            for (let i = 0; i < PostCommunionPrayer.length; i++) {
              let prayer = PostCommunionPrayer[i];
              PostCommunionPrayerHTML += prayer.data;
            }

            HTML += PostCommunionPrayerHTML;
          }

          HTML = HTML
            .replace(/<br class=kk \/>/gim, function (match, token) {
              return `${match} `;
            })
            .replace(/<h2 class="pn">(.*?)<\/h2>/gm, function (match, token) {
              return `<b>${match}</b><br>`;
            })
            .replace(/<h2 class="pn"/gim, `<h2 style="font-family=FiraSans-SemiBold;font-size:${20 * fontMultiplier}px;font-weight:600;line-height:${26 * fontMultiplier}px;letter-spacing:-0.1px;color:${colors.primary};"`)
            .replace(/class="redlight"/gim, "style='color:#880f30;font-size:17px;font-weight: normal;'")
            .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
            .replace(/<AF>.*<\/AF>/gm, '');


          __DEV__ && console.log(HTML);
          setSundayWorshipData(HTML);
        } else {
          setSundayWorshipData('');
        }
      } catch (error) {
        console.log(error);
      }
    };

    generateServiceSheet();
  }, [day, serviceType]);

  const openService = async (reading) => {
    let readingHrefs = reading.data.split('href="BibleRef/');
    readingHrefs.shift(); // First element is irrelevent so remove it

    // Extract the BibleRefNames from the readingHrefs
    const bibleRefNames = readingHrefs.map((startOfHref, index) => {
      return startOfHref.substring(0, startOfHref.indexOf('>') - 6)
    });


    const serviceContents = [];

    // Get service contents for each bible 
    for (let i = 0; i < bibleRefNames.length; i++) {

      const bibleRefName = bibleRefNames[i];
      const file = bibleHTML[`${bibleRefName}`];

      try {
        let uri;
        let html;

        if (Platform.OS === 'web') {
          html = file;
        } else {
          uri = Image.resolveAssetSource(file).uri;

          if (__DEV__) {
            html = await fetch(uri);
            html = await html.text();
          } else if (Platform.OS === 'ios') {
            // Release version - don't decode uri
            html = await RNFS.readFile(uri, 'utf8');
            // Debug version - need to decode uri
            // html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
          } else if (Platform.OS === 'android') {
            html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
            // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
          }
        }

        html = html.replace(/<p>\s+<\/p>/gim, '').replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ');
        serviceContents.push(html);
      } catch (error) {
        console.log(error);
      }

    }
  }

  const saveChurchInformation = async () => {
    const inputsEmpty = churchName.trim() === '' &&
      introduction.trim() === '' &&
      footer.trim() === '';

    if (!inputsEmpty) {
      await DataController.saveChurchInformation({
        churchName: churchName.trim(),
        introduction: introduction.trim(),
        footer: footer.trim(),
      });
    }
  };

  const closeService = () => setShowService();

  const closeModal = () => setModalVisible(false);

  const closeSWModal = () => {
    setGenerateModalVisible(false);
    setSWModalVisible(false);
  }

  const closeGenerateModal = async () => {
    await saveChurchInformation();
    setGenerateModalVisible(false)
  };

  const closePewSheetModal = () => setPewSheetModalVisible(false);

  const churchNameChanged = (value) => setChurchName(value);

  const introductionChanged = (value) => setIntroduction(value);

  const footerChanged = (value) => setFooter(value);

  const onLinkPress = async (event, href) => {
    const ref = href.replace('BibleRef/', '').replace('.html', '');
    const file = bibleHTML[`${ref}`];

    try {
      let uri;
      let html;

      if (Platform.OS === 'web') {
        html = file;

        html = html
          .replace(/<p>\s+<\/p>/gim, '')
          .replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
          .replace(/<AF>.*<\/AF>/gm, '');

        setBibleReading(html);
      } else {
        uri = Image.resolveAssetSource(file).uri;

        if (__DEV__) {
          html = await fetch(uri);
          html = await html.text();
        } else if (Platform.OS === 'ios') {
          // Release version - don't decode uri
          html = await RNFS.readFile(uri, 'utf8');
          // Debug version - need to decode uri
          // html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
        } else if (Platform.OS === 'android') {
          html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
          // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
        }
      }

      html = html.replace(/<h2 class="(?!passageref|pn).+">(.*?)<\/h2>/gm, '');

      html = html
        .replace(/<p>\s+<\/p>/gim, '')
        .replace(/&nbsp;/gm, ' ')
        .replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
        .replace(/<span class="\w+">\d+<\/span>(?!&nbsp;)/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<sup class="\w+">\d+<\/sup>(?!&nbsp;)/gim, function (match, token) {
          return ` ${match} `;
        })
        .replace(/<br class=kk \/>/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<h2 class="passageref">(.*?)<\/h2>/gm, function (match, token) {
          return match.replace(/\[|\]/gm, '');
        })
        .replace(/<h2 class="pn">(.*?)<\/h2>/gm, function (match, token) {
          return `<b>${match}</b><br>`;
        })
        .replace(/<h2 class="pn"/gim, `<h2 style="font-family=FiraSans-SemiBold;font-size:${20 * fontMultiplier}px;font-weight:600;line-height:${26 * fontMultiplier}px;letter-spacing:-0.1px;color:${colors.primary};"`)
        .replace(/class="redlight"/gim, "style='color:#880f30;font-size:20px;font-weight: normal;'")
        .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
        .replace(/<AF>.*<\/AF>/gm, '');

      __DEV__ && console.log(html);
      // console.log(html);

      setBibleReading(`${html}</div>`);
    } catch (error) {
      console.log(error);
      setBibleReading('Unable to load bible file');
    }

    setModalVisible(true);
  };

  const generatePewSheet = (copy) => {
    const offset = new Date().getTimezoneOffset() * 60 * 1000;
    const time = new Date(new Date().valueOf() - offset);

    const date = format(parseISO(day.Date), 'EEEE do MMMM yyyy')
    const weekTitle = day.WeekTitle;
    const dayTitle = day.DayTitle;
    const event = day.Event;
    const eventData = event && event[0].data;

    let pewHTML = sundayWorshipData;
    let pewHTMLRaw = pewHTML;

    // Add newline after Collect, Reading, Continuous headers
    pewHTML = pewHTML.replace('<div class="rightRed">Collect</div>', '<div class="rightRed">Collect</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="rightRed">Collect</div>', '<br><div class="rightRed" style="font-size: 1.3em;"><b>Collect</b></div>\n\n');
    pewHTML = pewHTML.replace('<div class="boldRight">Readings</div>', '\n\n<div class="boldRight">Readings</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="boldRight">Readings</div>', '\n\n<div class="boldRight" style="font-size: 1.3em;"><b>Readings</b></div>\n\n');
    pewHTML = pewHTML.replace('<div class="bibleReadingTitle">Continuous:</div>', '<div class="bibleReadingTitle">Continuous:</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="bibleReadingTitle">Continuous:</div>', '<div class="bibleReadingTitle" style="font-size: 1.3em;"><i>Continuous</i>:</div><br>\n\n');
    pewHTML = pewHTML.replace('<div class="bibleReadingTitle">Related:</div>', '<div class="bibleReadingTitle">Related:</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="bibleReadingTitle">Related:</div>', '<div class="bibleReadingTitle" style="font-size: 1.3em;"><i>Related</i>:</div><br>\n\n');
    pewHTML = pewHTML.replace('<div class="boldRight">Gospel Reading</div>', '<div class="boldRight">Gospel Reading</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="boldRight">Gospel Reading</div>', '<br><div class="boldRight" style="font-size: 1.3em;"><b>Gospel Reading</b></div><br>\n\n');
    pewHTML = pewHTML.replace('<div class="boldRight">New Testament Reading</div>', '<div class="boldRight">New Testament Reading</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="boldRight">New Testament Reading</div>', '<br><div class="boldRight" style="font-size: 1.3em;"><b>New Testament Reading</b></div>\n\n');
    pewHTML = pewHTML.replace('<div class="rightRed">Post Communion</div>', '\n\n<div class="rightRed">Post Communion</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace('<div class="rightRed">Post Communion</div>', '\n\n<br><div class="rightRed" style="font-size: 1.3em;"><b>Post Communion</b></div>\n\n');
    pewHTML = pewHTML.replace(/<div class="collectOr">or<\/div>/gm, '\n\n<div class="collectOr">or</div>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace(/<div class="collectOr">or<\/div>/gm, '\n\n<div class="collectOr"><b><i>or</i></b></div>\n\n');

    // Format ending of reading refrain
    pewHTML = pewHTML.replace(/<div class='TBTG'>/gm, "\n<div class='TBTG'>");
    pewHTMLRaw = pewHTMLRaw.replace(/<div class='TBTG'>/gm, "\n<div class='TBTG'>");
    pewHTML = pewHTML.replace(/<span class=TBTGSpan2>Thanks be to God.<\/span>/gm, '<span class=TBTGSpan2>Thanks be to God.</span>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace(/<span class=TBTGSpan2>Thanks be to God.<\/span>/gm, '<span class=TBTGSpan2>Thanks be to God.</span><br>\n\n');
    pewHTML = pewHTML.replace(/<span class=TBTGSpan2>Glory to you, O Lord.<\/span>/gm, '<span class=TBTGSpan2>Glory to you, O Lord.</span>\n\n');
    pewHTMLRaw = pewHTMLRaw.replace(/<span class=TBTGSpan2>Glory to you, O Lord.<\/span>/gm, '<span class=TBTGSpan2>Glory to you, O Lord.</span><br><br>\n\n');
    pewHTML = pewHTML.replace(/<span class=TBTGSpanAll>All<\/span>/gm, "<span class=TBTGSpanAll>All: </span>");
    pewHTMLRaw = pewHTMLRaw.replace(/<span class=TBTGSpanAll>All<\/span>/gm, "<span class=TBTGSpanAll><b>All: </b></span>");

    pewHTMLRaw = pewHTMLRaw.replace(/<div class="bibleReadingTitleRed"/gm, '<br><div class="bibleReadingTitleRed" style="font-size: 1.2em; font-weight: bold; margin-bottom: 8px;"');

    // Correct sup tag spacing
    pewHTML = pewHTML.replace(/\/sup>(?!\s)/gm, '/sup> ');
    pewHTML = pewHTML.replace(/&nbsp;/gm, ' ');
    pewHTML = pewHTML.replace(/<span class="redlight">&#149;<\/span>/gm, '•\n');
    pewHTML = pewHTML.replace(/<span class="redlight">&#149;<\/span>/gm, '•\n');
    pewHTML = pewHTML.replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '');
    pewHTML = pewHTML.replace(/<span[\s]+([^>]+)>&diams;&#xFE0E;<\/span>/gm, '\n');
    pewHTML = pewHTML.replace(/<div class="bibletext">/gm, '');
    pewHTML = pewHTML.replace(/\n{2,}/gm, '\n\n')
    pewHTML = pewHTML.replace(/&#14\d;/gm, '');
    pewHTML = pewHTML.replace(/&#151;/gm, '-');
    pewHTML = pewHTML.replace(/<span style='color:#880f30;font-size:17px;font-weight: normal;'><\/span>/gm, '•');
    pewHTML = pewHTML.replace(/<br \/>/gim, '\n')

    __DEV__ && console.log('generatePewSheet', pewHTML)

    // Remove HTML tags
    pewHTML = pewHTML.replace(/<[^>]*>?/gm, '');
    pewHTML = pewHTML.replace(/-->\d+/gm, '');
    pewHTML = pewHTML.replace(/-->/gm, '');

    let string = '';
    let stringRich = '';
    let copyrightPlain = "\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";

    if (copy) {
      stringRich = `<div style="font-size: 1.5em"><b>${date}</b></div>
${hasAlternatives ? `<div style="font-size: 1.5em"><b>Alternative ${alternativeIndex + 1} of ${day.alternatives.length}</b></div>` : ''}
<div>${dayTitle ? dayTitle : weekTitle}</div>
${eventData ? '<div>' + eventData + '</div>' : ''}
${day.AdditionReadingNotes ? `<br><b><i>Reading Notes</i>:</b> ${day.AdditionReadingNotes}<br>` : ''}
${pewHTMLRaw}`;

      string = `<div style="font-size: 1.5em"><b>${date}</b></div>
${hasAlternatives ? `<div style="font-size: 1.5em"><b>Alternative ${alternativeIndex + 1} of ${day.alternatives.length}</b></div>` : ''}
<div>${dayTitle ? dayTitle : weekTitle}</div>
${eventData ? '<div>' + eventData + '</div>' : ''}
${day.AdditionReadingNotes ? `Reading Notes: ${day.AdditionReadingNotes}` : ''}
${pewHTML}
${copyrightPlain}`;
    } else {
      stringRich = `${churchName.trim() !== '' ? '<div style="font-size: 2em"><b>' + churchName + '</b></div><br>\n\n' : ''}<div style="font-size: 1.5em"><b>${date}</b></div>
${hasAlternatives ? `<div style="font-size: 1.5em"><b>Alternative ${alternativeIndex + 1} of ${day.alternatives.length}</b></div>` : ''}
${dayTitle ? dayTitle : weekTitle}
${eventData ? '<div>' + eventData + '</div>' : ''}${introduction.trim() !== '' ? '\n\n<br><div style="font-size: 1.3em">' + introduction + '</div>\n' : ''}
${day.AdditionReadingNotes ? `<br><b><i>Reading Notes</i>:</b> ${day.AdditionReadingNotes}<br>` : ''}
${pewHTMLRaw}
${footer.trim() !== '' ? '\n' + '<div style="font-size: 1.3em">' + footer + '</div>' + '\n' : ''}`;

      string = `${churchName.trim() !== '' ? '<div style="font-size: 2em"><b>' + churchName + '</b></div><br>\n\n' : ''}<div style="font-size: 1.5em"><b>${date}</b></div>
${hasAlternatives ? `<div style="font-size: 1.5em"><b>${alternativeIndex + 1} of ${day.alternatives.length}</b></div>` : ''}
${dayTitle ? dayTitle : weekTitle}
${eventData ? '<div>' + eventData + '</div>' : ''}${introduction.trim() !== '' ? '\n\n' + introduction + '\n' : ''}
${day.AdditionReadingNotes ? `Reading Notes: ${day.AdditionReadingNotes}` : ''}
${pewHTML}
${footer.trim() !== '' ? '\n' + '<div>' + footer + '</div>' + '\n' : ''}
${copyrightPlain}`;
    }

    // {
    //   hasAlternatives && (
    //     <Text
    //       style={
    //         [styles.date, {
    //           fontSize: 17 * fontMultiplier,
    //           lineHeight: 24 * fontMultiplier,
    //           marginTop: -10,
    //           marginBottom: 12,
    //         }]}>
    //       {`Alternative ${alternativeIndex + 1} of ${day.alternatives.length}`}
    //     </Text>
    //   )
    // }


    let plaintext = string;
    let richtext = stringRich;

    plaintext = plaintext.replace(/<[^>]*>?/gm, '');
    richtext += '<br>' + "<div style='font-family: Fira Sans; font-size: smaller;font-style: italic'>" + copyrightPlain + "</div>";

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    if (copy) {
      toastRef.current.show('Service copied', { id: Date.now() });
    }
  };

  const generateServiceSheet = () => {
    try {
      generatePewSheet();
      if (Platform.OS === 'web') {
        closeGenerateModal();
      }
      closeSWModal();
      setTimeout(() => {
        setPewSheetModalVisible(true);
      }, 100);
    } catch (error) {
      console.log(error);
    }
  };

  const hasAlternatives = day.alternatives;
  const alternativeIndex = hasAlternatives && day.alternatives.findIndex((item) => item === day.id);

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Event' });

    let plaintext = bibleReading;
    let richtext = `<div style="font-size: 1em;">${bibleReading}</div>`;

    plaintext = DataController.formatHTMLToPlaintext(plaintext);
    plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    toastRef.current.show('Reading copied', { id: Date.now(), });
  };

  __DEV__ && console.log('NOTES: ', notes);

  return (
    <View>
      <ReadModal visible={modalVisible} closeModal={closeModal}>
        <View style={[styles.modalHeader, {
          borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
          borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
        }]}>
          <TouchableOpacity onPress={() => setModalVisible(false)}>
            <Image style={styles.menuIcon} source={images.Button_Close} />
          </TouchableOpacity>
          <View style={styles.modalHeaderRight}>
            <TouchableOpacity style={styles.buttonPadding} onPress={copyPressed}>
              <Image style={styles.menuIcon} source={images.Button_Copy} />
            </TouchableOpacity>
            {/* <TouchableOpacity onPress={() => generatePewSheet(true)}>
              <Image style={styles.menuIcon} source={images.Button_Copy} />
            </TouchableOpacity> */}
          </View>
        </View>
        <Toast ref={toastRef} style={{ marginBottom: 40 }} offsetBottom={60} />
        <ScrollView
          style={{
            flex: 1,
            height: '100%',
            backgroundColor: colors.accentWhite
          }}
          indicatorStyle="black"
          contentContainerStyle={styles.bibleScrollViewContainer}>
          <HTML
            ignoredStyles={[
              ...(bibleReading && bibleReading.includes('MsoNormal') ? ['font-family'] : []),
              'margin-left',
              'margin-right',
            ]}
            source={{ html: bibleReading ? bibleReading : '<div></div>' }}
            tagsStyles={readingTags}
            renderers={renderers}
            renderersProps={{
              fontMultiplier,
            }}
            classesStyles={readingClassStyles}
            baseFontStyle={{
              margin: 0,
              fontFamily: 'FiraSans-Regular',
              fontSize: 17 * fontMultiplier,
              fontWeight: 'normal',
              fontStyle: 'normal',
              lineHeight: 28 * fontMultiplier,
              letterSpacing: -0.06,
              color: colors.defaultText,
            }}
            defaultTextProps={{
              selectable: true,
            }}
          />
        </ScrollView>
      </ReadModal>
      <View style={styles.readingsSeparator} />
      <View style={{ marginTop: 15, marginBottom: -5.5 }}>
        {notes && (
          <HTML
            renderers={renderers}
            renderersProps={{
              fontMultiplier,
            }}
            tagsStyles={tagsStyles}
            onLinkPress={(event, href) => onLinkPress(event, href)}
            baseFontStyle={{
              fontSize: 16 * fontMultiplier,
              color: colors.defaultText,
              lineHeight: 24 * fontMultiplier,
            }}
            // source={{ html: `<note><i>Reading Notes:</i><tab>${DataController.formatHTMLToPlaintext(notes)}</tab></note>` }}
            source={{ html: `<note><i>Reading Notes:</i><tab>${notes}</tab></note>` }}
            defaultTextProps={{
              selectable: true,
            }}
          />
        )}
      </View>
      <View style={[styles.readingsContainer, { flexDirection: Dimensions.get('window').width > 500 ? 'row' : 'column' }]}>
        {readings.map((reading, index) => (
          <View
            style={{ flex: Dimensions.get('window').width > 500 ? 1 : -1, }}
            key={`${reading.option}-${index}`}>
            <Reading day={day} reading={reading} fontMultiplier={fontMultiplier} />
            {(day.DayOfWeek === 'Sunday' && (reading.option.includes('Principal Service') || reading.option.includes('Holy Communion'))
              || reading.option.includes('Principal Service')) ? (
              <View>
                <PewSheetModal
                  visible={pewSheetModalVisible}
                  closeModal={closePewSheetModal}>
                  <View style={{
                    width: 310,
                    height: 144,
                    backgroundColor: colors.accentWhite,
                    borderRadius: 10,
                    paddingVertical: 28,
                    paddingHorizontal: 28,
                  }}>
                    <Text
                      style={{
                        fontFamily: 'FiraSans-SemiBold',
                        fontSize: 17,
                        fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                        fontStyle: 'normal',
                        lineHeight: 24,
                        letterSpacing: 0.1,
                        color: colors.defaultText,
                        textAlign: 'center'
                      }}>
                      {'Pew sheet copied to clipboard'}
                    </Text>
                    <TouchableOpacity
                      style={{
                        width: 120,
                        height: 44,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: colors.primary,
                        borderRadius: 8,
                        alignSelf: 'center',
                        marginTop: 20,
                      }}
                      onPress={closePewSheetModal}>
                      <Text
                        allowFontScaling={false}
                        style={{
                          fontFamily: 'FiraSans-SemiBold',
                          fontSize: 17,
                          fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                          fontStyle: 'normal',
                          lineHeight: 24,
                          letterSpacing: 0.1,
                          color: colors.accentWhite,
                        }}>
                        {'Continue'}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </PewSheetModal>
                <SundayWorshipModal
                  // visible={true}
                  visible={swModalVisible}
                  closeModal={closeSWModal}>
                  <View style={[styles.modalHeader, {
                    borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
                    borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
                  }]}>
                    <TouchableOpacity onPress={() => setSWModalVisible(false)}>
                      <Image style={styles.menuIcon} source={images.Button_Close} />
                    </TouchableOpacity>
                    <Text style={styles.headerTitle} allowFontScaling={false}>
                      {'Service Sheet'}
                    </Text>
                    <View style={styles.modalHeaderRight}>
                      <TouchableOpacity onPress={() => generatePewSheet(true)}>
                        <Image style={styles.menuIcon} source={images.Button_Copy} />
                      </TouchableOpacity>
                    </View>
                  </View>
                  <Toast ref={toastRef} style={{ marginBottom: 40 }} offsetBottom={60} />
                  <GenerateServiceSheetModal
                    visible={generateModalVisible}
                    closeModal={closeGenerateModal}>
                    <View style={[styles.modalHeader, {
                      borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
                      borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
                      justifyContent: 'center',
                    }]}>
                      <Text style={[styles.headerTitle, { alignSelf: 'center' }]} allowFontScaling={false}>
                        {'Generate Service Sheet'}
                      </Text>
                      <TouchableOpacity
                        onPress={closeGenerateModal}
                        style={{
                          height: 44,
                          justifyContent: 'center',
                          alignItems: 'center',
                          position: 'absolute',
                          right: 16,
                        }}>
                        <Text
                          allowFontScaling={false}
                          style={{
                            fontFamily: 'FiraSans-Bold',
                            fontSize: 17,
                            fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
                            lineHeight: 24,
                            letterSpacing: -0.1,
                            color: colors.primary,
                          }}>
                          {'Close'}
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <ScrollView
                      style={{
                        flex: 1,
                        height: '100%',
                        backgroundColor: colors.accentWhite,
                        paddingBottom: 100,
                      }}
                      indicatorStyle="black"
                      keyboardShouldPersistTaps="handled"
                      contentContainerStyle={styles.bibleScrollViewContainer}>
                      <Text style={[styles.generateTextInputHeader, { marginTop: 6 }]}>
                        {'Church name'}
                      </Text>
                      <TextInput
                        ref={churchNameRef}
                        style={styles.generateTextInput}
                        numberOfLines={1}
                        value={churchName}
                        onChangeText={(input) => churchNameChanged(input)}
                        autoCapitalize="words"
                        returnKeyType="next"
                        onSubmitEditing={() => introductionRef.current?.focus()}
                      />
                      <Text style={styles.generateTextInputHeader}>
                        {'Introduction'}
                      </Text>
                      <TextInput
                        ref={introductionRef}
                        style={styles.generateTextInput}
                        numberOfLines={1}
                        value={introduction}
                        onChangeText={(input) => introductionChanged(input)}
                        autoCapitalize="sentences"
                        returnKeyType="next"
                        onSubmitEditing={() => footerRef.current?.focus()}
                      />
                      <Text style={styles.generateTextInputHeader}>
                        {'Footer'}
                      </Text>
                      <TextInput
                        ref={footerRef}
                        style={styles.generateTextInput}
                        numberOfLines={1}
                        value={footer}
                        onChangeText={(input) => footerChanged(input)}
                        autoCapitalize="sentences"
                        returnKeyType="go"
                        onSubmitEditing={generateServiceSheet}
                      />
                      <TouchableOpacity style={styles.generateButtonRed} onPress={generateServiceSheet}>
                        <Text style={styles.generateButtonRedText} allowFontScaling={false}>
                          {'Generate'}
                        </Text>
                      </TouchableOpacity>
                    </ScrollView>
                  </GenerateServiceSheetModal>
                  <ScrollView
                    style={{
                      flex: 1,
                      height: '100%',
                      backgroundColor: colors.accentWhite
                    }}
                    indicatorStyle="black"
                    contentContainerStyle={styles.bibleScrollViewContainer}>
                    <View>
                      <View style={[styles.sundayWorshipHeader, {
                        flexDirection: Dimensions.get('window').width >= 390 ? 'row' : 'column',
                        alignItems: Dimensions.get('window').width >= 390 ? 'center' : undefined,
                      }]}>
                        <View style={styles.sundayWorshipLogoContainer}>
                          <Image style={styles.sundayWorshipLogo} source={images.Icon_SW_Active} />
                          <Text
                            allowFontScaling={false}
                            style={[styles.sundayWorshipHeaderText, {
                              fontSize: 17 * fontMultiplier,
                              lineHeight: 24 * fontMultiplier,
                            }]}>
                            {'Principal Service'}
                          </Text>
                        </View>
                        <TouchableOpacity
                          style={[styles.generateButton, {
                            alignSelf: Dimensions.get('window').width >= 390 ? undefined : 'flex-end',
                          }]}
                          onPress={() => setGenerateModalVisible(true)}>
                          <Text style={styles.generateText} allowFontScaling={false}>
                            {'Generate Service Sheet'}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                    <View style={styles.sundayWorshipSeparator} />
                    <View style={styles.sundayWorshipDayHeader}>
                      <Header day={day} fontMultiplier={fontMultiplier} />
                      {hasAlternatives && (
                        <Text
                          style={
                            [styles.date, {
                              fontSize: 17 * fontMultiplier,
                              lineHeight: 24 * fontMultiplier,
                              marginTop: -10,
                              marginBottom: 12,
                            }]}>
                          {`Alternative ${alternativeIndex + 1} of ${day.alternatives.length}`}
                        </Text>
                      )}
                      {day.AdditionReadingNotes && (
                        <View>
                          <HTML
                            renderers={renderers}
                            renderersProps={{
                              fontMultiplier,
                            }}
                            tagsStyles={readingTags}
                            classesStyles={readingClassStyles}
                            baseFontStyle={{
                              fontSize: 17 * fontMultiplier,
                              color: colors.defaultText,
                              lineHeight: 28 * fontMultiplier,
                            }}
                            source={{ html: `<div>Reading Notes: ${day.AdditionReadingNotes}</div>` }}
                            defaultTextProps={{
                              selectable: true,
                            }}
                          />

                          <Text
                            style={{
                              fontFamily: 'FiraSans-Italic',
                              fontWeight: 'normal',
                              fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
                              fontSize: 17 * fontMultiplier,
                              lineHeight: 24 * fontMultiplier,
                              marginTop: -8,
                              marginBottom: 12,
                              color: colors.defaultText,
                            }}>
                            {'Reading Notes: '}
                            <Text
                              style={{
                                fontFamily: 'FiraSans-Regular',
                                fontStyle: 'normal',
                              }}>
                              {DataController.formatHTMLToPlaintext(day.AdditionReadingNotes)}
                            </Text>
                          </Text>
                        </View>
                      )}
                    </View>
                    <View style={styles.sundayWorshipSeparator} />
                    {/* <WebView
                      originWhitelist={['*']}
                      style={{
                        backgroundColor: colors.primary,
                        height: '100%',
                      }}
                      // source={{ uri: 'https://www.google.com' }}
                      source={{ html: `<div>${sundayWorshipData}</div>` }}
                    /> */}
                    <HTML
                      ignoredStyles={[
                        ...(sundayWorshipData && sundayWorshipData.includes('MsoNormal') ? ['font-family'] : []),
                        'margin-left',
                        'margin-right',
                      ]}
                      renderers={renderers}
                      renderersProps={{
                        fontMultiplier,
                      }}
                      tagsStyles={readingTags}
                      classesStyles={readingClassStyles}
                      baseFontStyle={{
                        fontSize: 17 * fontMultiplier,
                        color: colors.defaultText,
                        lineHeight: 28 * fontMultiplier,
                        textDecorationLine: 'none'
                      }}
                      source={{ html: `<div>${sundayWorshipData}</div>` }}
                      defaultTextProps={{
                        selectable: true,
                      }}
                    />
                  </ScrollView>
                </SundayWorshipModal>
                <ServiceSheetButton handlePress={() => setSWModalVisible(true)} />
              </View>
            ) : null}
            {/*
            {reading.option.includes('Prayer') ?
              <FullServiceButton handlePress={() => openService(reading)} />
              : null} */}
          </View>
        ))}

      </View>
      <View style={styles.readingsSeparator} />
    </View>
  );
};

const CollectOptions = ({ }) => {
  return (
    <View>

    </View>
  );
};

const Collect = ({ day, allCollects, changeCollect, collectOption, canEdit, dimensions, fontMultiplier }) => {
  const toast = useToast();

  const [collect, setCollect] = useState([]);

  useEffect(() => {
    // __DEV__ && console.log('COLLECT', collectOption, allCollects);

    if (collectOption.value === 'Show all') {
      setCollect(allCollects);
    } else if (collectOption.value === 'Collect 1') {
      if (allCollects[0]) {
        setCollect([allCollects[0]])
      } else if (allCollects.length > 0) {
        setCollect([allCollects[allCollects.length - 1]]);
      }
    } else if (collectOption.value === 'Collect 2') {
      if (allCollects[1]) {
        setCollect([allCollects[1]])
      } else if (allCollects.length > 0) {
        setCollect([allCollects[allCollects.length - 1]]);
      }
    } else if (collectOption.value === 'Collect 3') {
      if (allCollects[2]) {
        setCollect([allCollects[2]])
      } else if (allCollects.length > 0) {
        setCollect([allCollects[allCollects.length - 1]]);
      }
    }
  }, [collectOption, day])

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Collect' });

    let string = '';

    for (let i = 0; i < collect.length; i++) {
      let data = collect[i];

      string += data.data + '\n\n';
    }

    string = string.replace(/<[^>]*>?/gm, '');
    Clipboard.setString(string);
    toast.show('Collect copied', { id: Date.now() });
  };

  return (
    <Dropdown
      label={allCollects.length === 1 ? 'Collect' : collectOption.value === 'Show all' ? 'Collects' : collectOption.value}
      canEdit={canEdit}
      editText={`Change to Collect ${collectOption === 1 ? 2 : 1}`}
      copyPressed={copyPressed}
      editPressed={changeCollect}
      collectSelect={canEdit}
      dropdownOpen={true}
      day={day}
      allCollects={allCollects}>
      {collect.map((item, index) => (
        <View key={`Collect-${index}`}>
          <HTML
            baseFontStyle={tagsStyles.p}
            tagsStyles={tagsStyles}
            source={{ html: item.data }}
            defaultTextProps={{
              selectable: true,
            }}
            containerStyle={{
              marginBottom: index === collect.length - 1 ? 0 : 12
            }}
          />
          {collect.length > 1 && index !== collect.length - 1 && (
            <HTML
              baseFontStyle={{
                fontFamily: 'FiraSans-SemiBoldItalic',
                fontSize: 16 * fontMultiplier,
                fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
                lineHeight: 22 * fontMultiplier,
                letterSpacing: 0.1,
                color: colors.primary,
              }}
              tagsStyles={tagsStyles}
              source={{ html: `<div>or</div>` }}
              defaultTextProps={{
                selectable: true,
              }}
              containerStyle={{
                marginBottom: 12
              }}
            />
          )}
        </View>
      ))}
    </Dropdown>
  );
};

const Events = ({ events, fontMultiplier }) => {
  return (
    <View style={styles.eventContainer}>
      {events.map((event) => (
        <Event event={event} fontMultiplier={fontMultiplier} key={`${event.data}-${event.option}`} />
      ))}
    </View>
  );
};

const Event = ({ event, fontMultiplier }) => {
  const shouldExpand = DataController.eventShouldExpand(event.option || event.data);

  if (!shouldExpand) {
    const dropdownStyle = DataController.getDropdownStyle(event.option);
    __DEV__ && console.log('dropdownStyle', dropdownStyle);

    return (
      <NoDropdown
        label={`${event.data}${DataController.eventShouldShowOption(event.option) ? ` (${event.option})` : ''}`}
        dropdownLabelStyle={dropdownStyle}
      />
    );
  }

  const toast = useToast();
  const toastRef = useRef();

  const [modalVisible, setModalVisible] = useState(false);
  const [bibleReading, setBibleReading] = useState(null);

  const eventTagsStyles = {
    p: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 22 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    a: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
    },
    i: {
      fontFamily: 'FiraSans-Italic',
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      color: colors.defaultText,
    },
    b: {
      fontFamily: 'FiraSans-Bold',
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
    },
    h1: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginTop: 16,
      marginBottom: 8,
    },
    h2: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginTop: 16,
      marginBottom: 8,
    },
    tab: {
      fontFamily: 'FiraSans-Regular',
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    line: {
      fontSize: 16 * fontMultiplier,
      lineHeight: 24 * fontMultiplier,
    },
  };

  const eventClassesStyles = {
    eventReadingsContainer: {
    },
    'ui-link': {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      textDecorationLine: 'underline',
      marginBottom: 0,
    },
    biog: {
      marginTop: 8,
    },
    AdditionalLectionary: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      // marginBottom: 4,
    },
    'plus-S': {
      display: 'none',
    },
    eventReadingHeader: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 18 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.accentBlack,
      overflow: 'visible',
      marginBottom: 16,
    },
    passageref: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    rightRed: {
      fontFamily: 'FiraSans-SemiBoldItalic',
      fontSize: 17 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: 0.1,
      color: colors.red,
      textAlign: 'right',
    }
  };

  const readingTagsStyles = {
    p: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 0,
    },
    b: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
    a: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
      marginBottom: 10,
    },
  };

  const readingTags = {
    h2: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      marginTop: 16,
      marginBottom: 8,
    },
  };

  const readingClassStyles = {
    passageref: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    pn: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    },
    bibletext: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
    ww: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginHorizontal: 3,
      bottom: 0,
    },
    uu: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginEnd: 3,
      bottom: 0,
    },
    cc: {
      fontSize: 20 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
      marginEnd: 3,
    },
    'plus-S': classesStyles['plus-S'],
    'plus-Z': classesStyles['plus-S'],
    'plus-C': classesStyles['plus-S'],
    'plus-B': classesStyles['plus-S'],
    'plus-FT': classesStyles['plus-S'],
    fnote: classesStyles['plus-S'],
    redlight: {
      fontSize: 24 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
    }
  };

  const onLinkPress = async (event, href) => {
    const ref = href.replace('BibleRef/', '').replace('.html', '');
    const file = bibleHTML[`${ref}`];

    try {
      let uri;
      let html;

      if (Platform.OS === 'web') {
        html = file;
      } else {
        uri = Image.resolveAssetSource(file).uri;

        if (__DEV__) {
          html = await fetch(uri);
          html = await html.text();
        } else if (Platform.OS === 'ios') {
          // Release version - don't decode uri
          html = await RNFS.readFile(uri, 'utf8');
          // Debug version - need to decode uri
          //  html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
        } else if (Platform.OS === 'android') {
          html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
          // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
        }
      }

      html = html.replace(/<h2 class="(?!passageref|pn).+">(.*?)<\/h2>/gm, '');

      html = html
        .replace(/<p>\s+<\/p>/gim, '')
        .replace(/<!--[\s\S]*?-->/gm, '')
        .replace(/&nbsp;/gm, ' ')
        // .replace(/<div class="bibletext">\n<p>/gm, '<div class="bibletext">\n')
        .replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
        .replace(/<span class="\w+">\d+<\/span>(?!&nbsp;)/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<sup class="\w+">\d+<\/sup>(?!&nbsp;)/gim, function (match, token) {
          return ` ${match} `;
        })
        .replace(/<br class=kk \/>/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<h2 class="passageref">(.*?)<\/h2>/gm, function (match, token) {
          return match.replace(/\[|\]/gm, '');
        })
        .replace(/<h2 class="pn">(.*?)<\/h2>/gm, function (match, token) {
          return `<b>${match}</b><br>`;
        })
        .replace(/<h2 class="pn"/gim, `<h2 style="font-family=FiraSans-SemiBold;font-size:${20 * fontMultiplier}px;font-weight:600;line-height:${26 * fontMultiplier}px;letter-spacing:-0.1px;color:${colors.primary};"`)
        .replace(/class="redlight"/gim, "style='color:#880f30;font-size:20px;font-weight: normal;'")
        .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
        .replace(/<AF>.*<\/AF>/gm, '');

      setBibleReading(html);
    } catch (error) {
      console.log(error);
    }

    setModalVisible(true);
  };

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Event' });

    let plaintext = '';
    let richtext = '';

    if (event.data) {
      richtext += `<b>${event.data}${(event.option && DataController.eventShouldShowOption(event.option)) ? ` (${event.option})` : ''}</b>\n\n`;
      plaintext += event.data + `${(event.option && DataController.eventShouldShowOption(event.option)) ? ` (${event.option})` : ''}\n\n`;
    }

    const eventCollect = event.EventCollect;
    const eventReadings = event.EventReadings;
    const eventPrayer = event['Event Post Communion prayer'];
    const eventBiog = event['Event biog'];

    if (eventReadings) {
      for (let j = 0; j < eventReadings.length; j++) {
        let reading = eventReadings[j];

        const heading = reading.option;
        const headingRichtext = heading.replace(/\n/gm, '<br>');

        richtext += `<br><br><b><u>${headingRichtext}</u></b>`;
        plaintext += `\n${DataController.formatHTMLToPlaintext(heading)}\n\n`;

        let richtextData = reading.data;

        let plaintextData = reading.data
        plaintextData = plaintextData.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
        plaintextData = plaintextData.replace(RegExp("(</a>)", 'g'), "</span>");
        plaintextData = plaintextData.replace(/\n/gm, ' ');

        richtext += `<p>${richtextData}</p>`;
        plaintext += DataController.formatHTMLToPlaintext(plaintextData);
      }
    }

    if (eventCollect) {
      richtext += '<br><br><div><b><i>Collect</i></b>\n</div>'
      plaintext += '\n\nCollect\n\n';

      for (let j = 0; j < eventCollect.length; j++) {
        const collect = eventCollect[j];

        richtext += `<div>${collect.data}</div>`;
        plaintext += DataController.formatHTMLToPlaintext(collect.data);

        if (eventCollect[j + 1] !== undefined) {
          richtext += '\n<b><i>or</i></b>\n'
          plaintext += '\n\nor\n\n';
        }
      }
    }

    if (eventPrayer) {
      richtext += '<br><br><div><b><i>Post Communion Prayer</i></b>\n</div>'
      plaintext += '\n\nPost Communion Prayer\n\n';

      for (let j = 0; j < eventPrayer.length; j++) {
        const prayer = eventPrayer[j];

        richtext += `<div>${prayer.data}</div>`;
        plaintext += DataController.formatHTMLToPlaintext(prayer.data);

        if (eventPrayer[j + 1] !== undefined) {
          richtext += '<br><br>'
          plaintext += '\n\n';
        }
      }
    }

    if (eventBiog) {
      richtext += '<br><br><div><b><i>Biography</i></b>\n</div>'
      plaintext += '\n\nBiography\n\n';

      for (let j = 0; j < eventBiog.length; j++) {
        const biog = eventBiog[j];

        richtext += `<div>${biog.data}</div>`;
        plaintext += DataController.formatHTMLToPlaintext(biog.data);

        if (eventBiog[j + 1] !== undefined) {
          richtext += '<br><br>'
          plaintext += '\n\n';
        }
      }

      const eventCopyright = '<p class=biog>Extract from <i>Saints on Earth: A biographical companion to Common Worship</i> by John H Darch and Stuart K Burns</p>';

      richtext += `${eventCopyright}`;
      plaintext += `\n\n${DataController.formatHTMLToPlaintext(eventCopyright)}`;
    }

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    if (eventBiog) {
      toast.show('Biography copied', { id: Date.now() });
    } else {
      toast.show('Event copied', { id: Date.now(), });
    }
  };

  const modalCopyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Event Reading' });

    let plaintext = bibleReading;
    let richtext = `<div style="font-size: 1em;">${bibleReading}</div>`;

    plaintext = DataController.formatHTMLToPlaintext(plaintext);
    plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    toastRef.current.show('Reading copied', { id: Date.now() });
  };

  const editPressed = () => {
    toast.show('TBC', { id: Date.now() });
  };

  const eventCopyright = '<p class=biog>Extract from <i>Saints on Earth: A biographical companion to Common Worship</i> by John H Darch and Stuart K Burns</p>';

  const formatReadings = (readings) => {
    let result = '';
    result += readings
      .replace(/<i>also<\/i>/gim, '<i>also </i>')
      .replace(/<i>especially<\/i>/gim, '<i>especially </i>')
      .replace(/<i>or<\/i>/gim, '<i>or </i>')
      .replace(/<img src=\'blueArrow.png\' class=\'BibleLinkImage\' \/>/gm, '')
      .replace(/>\s+/gim, '>')
      .replace(/<line>/gim, '<br><br><line>')
      .replace(/<\/line>(?!$)(?!<br><br>)/gim, '</line><br><br>')
      .replace(/<br \/>/gim, '<br><br>')
      .replace(/\n/gim, '')

    // console.log(result);

    return result;
    // return result;
  };

  const html = `
${event.EventReadings ? '<span class="eventReadingHeader">' + event.EventReadings[0].option + '</span>' + '<line class="eventReadingsContainer">' + formatReadings(event.EventReadings[0].data) + '</line>' : ''}
${event.EventCollect ? '<h1>Collect</h1>' + event.EventCollect[0].data.replace(/>\s+/gim, '>') : ''}
${event['Event Post Communion prayer'] ? '<h1>Post Communion Prayer</h1>' + event['Event Post Communion prayer'][0].data.replace(/>\s+/gim, '>') : ''}
${event['Event biog'] ? '<h1>Biography</h1>' + event['Event biog'][0].data + eventCopyright : ''}
`;

  const closeModal = () => setModalVisible(false);

  const dropdownStyle = DataController.getDropdownStyle(event.option);
  __DEV__ && console.log('dropdownStyle', dropdownStyle);

  return (
    <Dropdown
      label={`${event.data}${DataController.eventShouldShowOption(event.option) ? ` (${event.option})` : ''}`}
      copyPressed={copyPressed}
      dropdownLabelStyle={dropdownStyle}
      dropdownOpen={false}
      eventColour={event.EventsColour}>
      <ReadModal visible={modalVisible} closeModal={closeModal}>
        <View style={[styles.modalHeader, {
          borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
          borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
        }]}>
          <TouchableOpacity onPress={() => setModalVisible(false)}>
            <Image style={styles.menuIcon} source={images.Button_Close} />
          </TouchableOpacity>
          <View style={styles.modalHeaderRight}>
            <TouchableOpacity style={styles.buttonPadding} onPress={modalCopyPressed}>
              <Image style={styles.menuIcon} source={images.Button_Copy} />
            </TouchableOpacity>
          </View>
        </View>
        <Toast ref={toastRef} style={{ marginBottom: 40 }} offsetBottom={60} />
        <ScrollView
          style={{
            flex: 1,
            height: '100%',
            backgroundColor: colors.accentWhite
          }}
          indicatorStyle="black"
          contentContainerStyle={styles.bibleScrollViewContainer}>
          <HTML
            ignoredStyles={[
              ...(bibleReading && bibleReading.includes('MsoNormal') ? ['font-family'] : []),
              'margin-left',
              'margin-right',
            ]}
            source={{ html: bibleReading ? bibleReading : '' }}
            tagsStyles={readingTags}
            classesStyles={readingClassStyles}
            renderers={renderers}
            renderersProps={{
              fontMultiplier,
            }}
            baseFontStyle={{
              margin: 0,
              fontFamily: 'FiraSans-Regular',
              fontSize: 17 * fontMultiplier,
              fontWeight: 'normal',
              fontStyle: 'normal',
              lineHeight: 26 * fontMultiplier,
              letterSpacing: -0.06,
              color: colors.defaultText,
            }}
            defaultTextProps={{
              selectable: true,
            }}
          />
        </ScrollView>
      </ReadModal>
      <HTML
        renderers={renderers}
        renderersProps={{
          fontMultiplier,
        }}
        baseFontStyle={{
          margin: 0,
          fontFamily: 'FiraSans-Regular',
          fontSize: 17 * fontMultiplier,
          fontWeight: 'normal',
          fontStyle: 'normal',
          lineHeight: 26 * fontMultiplier,
          letterSpacing: -0.06,
          color: colors.defaultText,
        }}
        tagsStyles={eventTagsStyles}
        classesStyles={eventClassesStyles}
        source={{ html: html }}
        onLinkPress={(_event, href) => onLinkPress(_event, href)}
        defaultTextProps={{
          selectable: true,
        }}
      />
    </Dropdown>
  );
};

const PostCommunionPrayer = ({ prayer }) => {
  const toast = useToast();

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Post Communion Prayer' });

    let string = prayer.data;
    string = string.replace(/<[^>]*>?/gm, '');
    Clipboard.setString(string);
    toast.show('Prayer copied', { id: Date.now() });
  };

  return (
    <Dropdown
      label="Post Communion Prayer"
      canEdit={false}
      dropdownOpen={true}
      copyPressed={copyPressed}>
      <HTML
        tagsStyles={tagsStyles}
        source={{ html: prayer.data }}
        defaultTextProps={{
          selectable: true,
        }}
      />
    </Dropdown>
  );
};

const AdditionalWeekdayLectionary = ({ reading, fontMultiplier }) => {
  const toast = useToast();
  const toastRef = useRef();

  const [modalVisible, setModalVisible] = useState(false);
  const [bibleReading, setBibleReading] = useState('');

  const readingTagsStyles = {
    p: styles.a,
    b: styles.a,
    a: styles.a,
  };

  const readingTags = {
    h2: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      marginTop: 16,
      marginBottom: 8,
    },
    p: {
      marginBottom: 8,
      margin: 0,
      fontFamily: 'FiraSans-Regular',
      fontSize: 17 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
    },
  };

  const readingClassStyles = {
    vv: {
      fontFamily: 'FiraSans-SemiBold',
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    },
    ww: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      // lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : 28 * fontMultiplier,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginHorizontal: 3,
      bottom: 0,
    },
    uu: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 12 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: Platform.OS === 'web' ? 12 * fontMultiplier : undefined,
      letterSpacing: -0.06,
      color: colors.defaultText,
      textAlignVertical: 'top',
      marginEnd: 3,
      bottom: 0,
    },
    cc: {
      fontSize: 20 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
      marginEnd: 3,
    },
    'plus-S': classesStyles['plus-S'],
    'plus-Z': classesStyles['plus-S'],
    'plus-C': classesStyles['plus-S'],
    'plus-B': classesStyles['plus-S'],
    'plus-FT': classesStyles['plus-S'],
    fnote: classesStyles['plus-S'],
    redlight: {
      fontSize: 24 * fontMultiplier,
      lineHeight: Platform.OS === 'web' ? 20 * fontMultiplier : undefined,
    }
  };

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Additional Weekday Lectionary' });

    let plaintext = reading.data;
    let richtext = `<div style="font-size: 1em;">${reading.data}</div>`;

    // __DEV__ && console.log(plaintext);

    plaintext = DataController.formatHTMLToPlaintext(plaintext, 'AdditionalWeekdayLectionary');
    plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";


    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    toast.show('Additional Lectionary copied', { id: Date.now(), });
  };

  const modalCopyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Additional Weekday Lectionary Reading' });

    let plaintext = bibleReading;
    let richtext = `<div style="font-size: 1em;">${bibleReading}</div>`;

    plaintext = DataController.formatHTMLToPlaintext(plaintext);
    plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";

    if (Platform.OS === 'web') {
      const blobHTML = new Blob([richtext], { type: 'text/html' });
      const blobPlain = new Blob([plaintext], { type: 'text/plain' });
      const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

      navigator.clipboard.write([clipboardItem]);
    } else {
      Clipboard.setString(plaintext);
    }

    toastRef.current.show('Reading copied', { id: Date.now(), });
  };

  const onLinkPress = async (event, href) => {
    const ref = href.replace('BibleRef/', '').replace('.html', '');
    const file = bibleHTML[`${ref}`];

    try {
      let uri;
      let html;

      if (Platform.OS === 'web') {
        html = file;
      } else {
        uri = Image.resolveAssetSource(file).uri;

        if (__DEV__) {
          html = await fetch(uri);
          html = await html.text();
        } else if (Platform.OS === 'ios') {
          // Release version - don't decode uri
          html = await RNFS.readFile(uri, 'utf8');
          // Debug version - need to decode uri
          // html = await RNFS.readFile(decodeURIComponent(uri), 'utf8');
        } else if (Platform.OS === 'android') {
          html = await RNFS.readFile(`android.resource://com.aimer.lectionary/raw/${uri}`, 'utf8');
          // html = await RNFS.readFile(`android.resource://com.aimer.lectionary.TEST/raw/${uri}`, 'utf8');
        }
      }

      html = html.replace(/<h2 class="(?!passageref|pn).+">(.*?)<\/h2>/gm, '');

      html = html
        .replace(/<p>\s+<\/p>/gim, '')
        .replace(/&nbsp;/gm, ' ')
        .replace('<p>', '').replace(/<sup class=\"fnote\">\*<\/sup>/gim, ' ')
        .replace(/<span class="\w+">\d+<\/span>(?!&nbsp;)/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<sup class="\w+">\d+<\/sup>(?!&nbsp;)/gim, function (match, token) {
          return ` ${match} `;
        })
        .replace(/<br class=kk \/>/gim, function (match, token) {
          return `${match} `;
        })
        .replace(/<h2 class="passageref">(.*?)<\/h2>/gm, function (match, token) {
          return match.replace(/\[|\]/gm, '');
        })
        .replace(/<h2 class="pn">(.*?)<\/h2>/gm, function (match, token) {
          return `<b>${match}</b><br>`;
        })
        .replace(/<h2 class="pn"/gim, `<h2 style="font-family=FiraSans-SemiBold;font-size:${20 * fontMultiplier}px;font-weight:600;line-height:${26 * fontMultiplier}px;letter-spacing:-0.1px;color:${colors.primary};"`)
        .replace(/class="redlight"/gim, "style='color:#880f30;font-size:20px;font-weight: normal;'")
        .replace(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/gm, '')
        .replace(/<AF>.*<\/AF>/gm, '');

      __DEV__ && console.log(html);

      setBibleReading(html);
    } catch (error) {
      console.log(error);
    }

    setModalVisible(true);
  };

  const closeModal = () => setModalVisible(false);

  return (
    <>
      <ReadModal visible={modalVisible} closeModal={closeModal}>
        <View style={[styles.modalHeader, {
          borderTopStartRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
          borderTopEndRadius: Platform.OS === 'web' && Dimensions.get('window').width > 624 ? 10 : 0,
        }]}>
          <TouchableOpacity onPress={() => setModalVisible(false)}>
            <Image style={styles.menuIcon} source={images.Button_Close} />
          </TouchableOpacity>
          <View style={styles.modalHeaderRight}>
            <TouchableOpacity style={styles.buttonPadding} onPress={modalCopyPressed}>
              <Image style={styles.menuIcon} source={images.Button_Copy} />
            </TouchableOpacity>
          </View>
        </View>
        <Toast ref={toastRef} style={{ marginBottom: 40 }} offsetBottom={60} />
        <ScrollView
          style={{
            flex: 1,
            height: '100%',
            backgroundColor: colors.accentWhite
          }}
          indicatorStyle="black"
          contentContainerStyle={styles.bibleScrollViewContainer}>
          <HTML
            ignoredStyles={[
              ...(bibleReading && bibleReading.includes('MsoNormal') ? ['font-family'] : []),
              'margin-left',
              'margin-right',
            ]}
            renderersProps={{
              fontMultiplier,
            }}
            source={{ html: bibleReading ? bibleReading : '<div></div>' }}
            tagsStyles={readingTags}
            renderers={renderers}
            classesStyles={readingClassStyles}
            baseFontStyle={{
              margin: 0,
              fontFamily: 'FiraSans-Regular',
              fontSize: 17 * fontMultiplier,
              fontWeight: 'normal',
              fontStyle: 'normal',
              lineHeight: 28 * fontMultiplier,
              letterSpacing: -0.06,
              color: colors.defaultText,
            }}
            defaultTextProps={{
              selectable: true,
            }}
          />
        </ScrollView>
      </ReadModal>
      <Dropdown
        label="Additional Weekday Lectionary"
        canEdit={false}
        dropdownOpen={true}
        copyPressed={copyPressed}>
        <HTML
          tagsStyles={tagsStyles}
          source={{ html: reading.data }}
          onLinkPress={(event, href) => onLinkPress(event, href)}
          defaultTextProps={{
            selectable: true,
          }}
        />
      </Dropdown>
    </>
  );
};

const Notes = ({ day, initialNote, fontMultiplier }) => {
  const toast = useToast();
  const inputRef = useRef(null);

  const context = useContext(AppContext);
  const { days, dimensions, user } = context;

  const [note, setNote] = useState(initialNote);
  const [dropdownOpen, setDropdownOpen] = useState(true);
  const [inputHeight, setInputHeight] = useState(54);

  const webStyles = {};

  useEffect(() => {
    setNote(initialNote);
  }, [initialNote]);

  useEffect(() => {
    EventRegister.addEventListener('notes/open-notes', focusInput);

    return () => EventRegister.removeEventListener('notes/open-notes');
  }, []);

  const focusInput = () => {
    try {
      setDropdownOpen(true);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 10);
    } catch (error) {
      console.log(error);
    }
  };

  const copyPressed = () => {
    !__DEV__ && FirebaseService.logEvent('day_copy_pressed', { block: 'Notes' });

    let string = note;
    string = string.replace(/<[^>]*>?/gm, '');
    Clipboard.setString(string);
    toast.show('Notes copied', { id: Date.now() });
  };

  const saveNote = async () => {
    if (note.trim() === '') {
      toast.show('Saving notes', { id: Date.now() });

      if (user) {
        let _note = { id: day.id };
        await DatabaseService.updateNote(user.email, user.requestToken, _note, true);
      }

      await DataController.removeNote(day.id);

      setNote(note.trim());
    } else {
      if (user) {
        let _note = { id: day.id, note: encodeURI(note) };
        await DatabaseService.updateNote(user.email, user.requestToken, _note);
      }

      await DataController.addNote(day.id, note);
    }

    toast.show('Notes saved', { id: Date.now() });

    EventRegister.emit('notes/updated');
  };

  const measureText = (event) => {
    setInputHeight(event.nativeEvent.layout.height);
  };

  return (
    <>
      <Dropdown
        dropdownOpen={dropdownOpen}
        label="Notes"
        canEdit={false}
        copyPressed={copyPressed}>
        <TextInput
          ref={inputRef}
          inputAccessoryViewID={'doneToolbarID'}
          placeholder="Add your notes here"
          placeholderTextColor={colors.grey60}
          style={[styles.notesInput, {
            fontSize: 16 * fontMultiplier,
            lineHeight: 22 * fontMultiplier,
            minHeight: Platform.OS === 'web' ? inputHeight : undefined,
          }]}
          multiline={true}
          onBlur={() => saveNote()}
          onChangeText={(value) => setNote(value)}
          value={note}
        />
        <Text
          onLayout={measureText}
          style={[styles.notesInput, {
            fontSize: 16 * fontMultiplier,
            lineHeight: 22 * fontMultiplier,
            position: 'absolute',
            // visibility: 'hidden',
            color: colors.transparent,
          }]}
          pointerEvents="none">
          {note}
        </Text>
      </Dropdown>
    </>
  );
};

const DropdownAndroid = ({ collectSelect, day, allCollects, children, canEdit, editText, label, copyPressed, editPressed, eventColour }) => {
  const ref = useAnimatedRef();
  const open = useSharedValue(false);
  const offset = useSharedValue(0);
  const height = useSharedValue(0);
  const transition = useDerivedValue(() => {
    return open.value ? withTiming(1) : withTiming(0);
  });

  const animatedStyles = useAnimatedStyle(() => {
    return {
      transform: [{ rotate: `${offset.value}deg` }],
    };
  });

  const heightStyles = useAnimatedStyle(() => {
    return {
      height: 1 + transition.value * height.value,
      opacity: transition.value === 0 ? 0 : 1,
      overflow: Platform.OS === 'android' ? 'hidden' : 'visible',
    };
  });

  const handlePress = () => {
    if (height.value === 0) {
      runOnUI(() => {
        'worklet';
        height.value = measure(ref).height + 32;
        // console.log(height.value);
      })();
    }

    offset.value = withTiming(open.value ? 0 : 90);
    open.value = !open.value;
  };

  const containerBorder = {
    borderBottomStartRadius: open ? 0 : 4,
    borderBottomEndRadius: open ? 0 : 4,
  };

  return (
    <Animated.View style={styles.notesContainer}>
      <TouchableOpacity
        style={[styles.dropdown, containerBorder]}
        activeOpacity={0.5}
        onPress={handlePress}>
        <Animated.View style={animatedStyles}>
          <Image style={styles.dropdownIcon} source={images.Button_Expand_Red} />
        </Animated.View>
        <Text style={styles.dropdownLabel} allowFontScaling={false}>
          {label}
        </Text>
        {eventColour && (
          <View style={styles.eventColorContainer}>
            <Text style={styles.eventColorText} allowFontScaling={false}>
              {eventColour[0].data}
            </Text>
          </View>
        )}
        {canEdit && !collectSelect && (
          <TouchableOpacity onPress={editPressed}>
            <Text style={styles.editText} allowFontScaling={false}>{editText}</Text>
          </TouchableOpacity>
        )}
        {canEdit && collectSelect && (
          <TouchableOpacity onPress={editPressed}>
            <Text style={styles.editText} allowFontScaling={false}>{editText}</Text>
          </TouchableOpacity>
        )}
        <TouchableOpacity onPress={copyPressed}>
          <Image style={styles.dropdownIcon} source={images.Button_Copy} />
        </TouchableOpacity>
      </TouchableOpacity>
      <Animated.View style={heightStyles}>
        <View style={styles.dropdownContainer} ref={ref}>
          {children}
        </View>
      </Animated.View>
    </Animated.View>
  );
};

const NoDropdown = ({ label, dropdownLabelStyle }) => (
  <View style={styles.notesContainer}>
    <View style={styles.dropdown}>
      <Text style={[styles.noDropdownLabel, dropdownLabelStyle]} allowFontScaling={false}>
        {label}
      </Text>
    </View>
  </View>
);

const Dropdown = ({ collectSelect, day, allCollects, dropdownOpen, children, canEdit, editText, label, dropdownLabelStyle, copyPressed, editPressed, eventColour }) => {
  // const openAnim = useRef(new ReactAnimated.Value(0)).current;
  const disclosureAnim = useRef(new ReactAnimated.Value(dropdownOpen ? 90 : 0)).current;
  const [open, setOpen] = useState(dropdownOpen);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [dimensions, setDimensions] = useState(0);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const getCollectType = async () => {
      const collectType = await DataController.getCollects();

      setSelectedOption({ type: 'collect', label: collectType, value: collectType });
    };

    if (allCollects) {
      // console.log(allCollects);

      const array = [{ type: 'collect', label: 'Show all', value: 'Show all' }];

      for (let i = 0; i < allCollects.length; i++) {
        array.push({ type: 'collect', label: `Collect ${i + 1}`, value: `Collect ${i + 1}` })
      }

      setOptions(array);
      getCollectType();
    }
  }, [allCollects, day]);

  useEffect(() => {
    setOpen(dropdownOpen);
  }, [dropdownOpen]);

  useEffect(() => {
    EventRegister.addEventListener('day/close-dropdowns', () => {
      if (__DEV__) {
        return;
      }

      expandClose();
      setOpen(false);
    });

    EventRegister.addEventListener('setting/collect-type-changed', async () => {
      const type = await DataController.getCollects();
      setSelectedOption({ type: 'collect', label: type, value: type });
    });

    return () => {
      EventRegister.removeEventListener('day/close-dropdowns');
      EventRegister.removeEventListener('setting/collect-type-changed');
    }
  }, []);

  const expandOpen = (value) => {
    // ReactAnimated.spring(openAnim, {
    //   toValue: dimensions,
    //   friction: 50,
    //   useNativeDriver: false,
    // }).start();

    ReactAnimated.spring(disclosureAnim, {
      toValue: 90,
      friction: 50,
      useNativeDriver: false,
    }).start();
  };

  const expandClose = () => {
    // ReactAnimated.spring(openAnim, {
    //   toValue: 0,
    //   friction: 50,
    //   useNativeDriver: false,
    // }).start();

    ReactAnimated.spring(disclosureAnim, {
      toValue: 0,
      friction: 50,
      useNativeDriver: false,
    }).start();
  };

  const handlePress = () => {
    !__DEV__ && FirebaseService.logEvent('day_block_pressed', { block: label });

    if (open) {
      expandClose();
    } else {
      expandOpen();
    }

    setOpen(!open);
  };

  const openSelect = () => {
    setSelectOpen(!selectOpen);
  }

  const onSelectItem = (item) => {
    updateOptions(item)
    openSelect();
  };

  const onOpen = () => console.log(true);;
  // const onOpen = () => EventRegister.emit('filter/close-filter', filterIndex);

  const updateOptions = (item) => console.log(item);

  const changeOption = async (item) => {
    !__DEV__ && FirebaseService.logEvent('collect_option_changed', { option: item.value });

    await DataController.saveCollects(item.value);
    setSelectedOption(item);
    openSelect();
  };

  const measureDimensions = (event) => {
    const _height = event.nativeEvent.layout.height;
    setDimensions(_height);
  };

  // const heightStyles = {
  //   overflow: Platform.OS === 'ios' ? 'scroll' : 'hidden',
  //   height: openAnim,
  // };

  const animatedStyles = {
    transform: [
      {
        rotate: disclosureAnim.interpolate({
          inputRange: [0, 90],
          outputRange: ['0deg', '90deg'],
        }),
      },
    ],
  };

  const containerBorder = {
    borderBottomStartRadius: open ? 0 : 4,
    borderBottomEndRadius: open ? 0 : 4,
  };

  let background =
    eventColour ? eventColour[0].data === 'Hangings removed' ? 'grey' : eventColour[0].data.split(' ')[0].toLowerCase() : null;
  const backgroundHex = background && DataController.colourNameToHex(background);
  const textColor = backgroundHex ? DataController.getTextColor(backgroundHex) : colors.accentWhite;

  return (
    <ReactAnimated.View style={styles.notesContainer}>
      <TouchableOpacity
        style={[styles.dropdown, containerBorder]}
        activeOpacity={0.5}
        onPress={handlePress}>
        <ReactAnimated.View style={animatedStyles}>
          <Image style={styles.dropdownIcon} source={images.Button_Expand_Red} />
        </ReactAnimated.View>
        <Text style={[styles.dropdownLabel, dropdownLabelStyle]} allowFontScaling={false}>
          {label}
        </Text>
        {eventColour && (
          <View
            style={[
              styles.eventColorContainer,
              {
                height: background === 'White' ? 18 : 16,
                backgroundColor: backgroundHex ? backgroundHex : 'grey',
                borderWidth: background === 'White' ? 1 : 0,
              },
            ]}>
            <Text
              style={[styles.eventColorText, { color: textColor }]}
              allowFontScaling={false}>
              {eventColour[0].data}
            </Text>
          </View>
        )}
        {/* {canEdit && ( */}
        {canEdit && !collectSelect && (
          <TouchableOpacity onPress={editPressed}>
            <Text style={styles.editText} allowFontScaling={false}>{editText}</Text>
          </TouchableOpacity>
        )}
        {/* {canEdit && collectSelect && false && ( */}
        {canEdit && collectSelect && (
          <View>
            <Popover
              placement={[PopoverPlacement.BOTTOM, PopoverPlacement.TOP]}
              backgroundStyle={{
                opacity: 0.2,
              }}
              arrowSize={{ width: 0, height: 0 }}
              isVisible={selectOpen}
              onRequestClose={openSelect}
              from={(
                <TouchableOpacity
                  style={{
                    flexDirection: 'row', alignItems: 'center',
                  }}
                  onPress={openSelect}>
                  <Text style={styles.editText} allowFontScaling={false}>{'Select Collect'}</Text>
                  <Image
                    style={{
                      width: 44,
                      height: 44,
                      marginStart: -8,
                      transform: selectOpen ? [{ rotateX: '180deg' }] : [{ rotateX: '0deg' }],
                    }}
                    source={images.Button_Collapse_Red}
                  />
                </TouchableOpacity>
              )}>
              <View
                style={{
                  minWidth: 200,
                  maxWidth: 270,
                  minHeight: 44,
                  backgroundColor: colors.accentWhite,
                  borderWidth: 1,
                  borderColor: colors.grey40,
                  borderRadius: 4,
                }}>
                {options.map((item, index) => (
                  <View key={`${index}`}>
                    <TouchableOpacity
                      style={{
                        height: 44,
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingStart: 10,
                      }}
                      activeOpacity={0.6}
                      onPress={() => changeOption(item)}>
                      <Text
                        style={{
                          fontFamily: 'FiraSans-SemiBold',
                          fontSize: 17,
                          fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                          fontStyle: 'normal',
                          letterSpacing: 0.1,
                          lineHeight: 24,
                          color: colors.defaultText,
                        }}
                        allowFontScaling={false}>
                        {item.label}
                      </Text>
                      {item.value === selectedOption?.value && (
                        <Image
                          style={{
                            height: 44,
                            width: 44,
                          }}
                          source={images.Button_Tick}
                        />
                      )}
                    </TouchableOpacity>
                    {index !== options.length - 1 && (
                      <View style={{ height: 2, backgroundColor: colors.grey40 }} />
                    )}
                  </View>
                ))}
              </View>
            </Popover>
          </View>
        )}
        <TouchableOpacity onPress={copyPressed}>
          <Image style={styles.dropdownIcon} source={images.Button_Copy} />
        </TouchableOpacity>
      </TouchableOpacity>
      <Collapsible collapsed={!open} renderChildrenCollapsed={true}>
        <View
          collapsable={false}
          style={[styles.dropdownContainer]}
          onLayout={(event) => measureDimensions(event)}>
          {children}
        </View>
      </Collapsible>
      {/* <ReactAnimated.View style={heightStyles}>
        <View style={styles.dropdownContainer} onLayout={(event) => measureDimensions(event)}>
          {children}
        </View>
      </ReactAnimated.View> */}
    </ReactAnimated.View>
  );
};

const BottomBar = ({ showLeft, showRight, handleLeftPress, handleRightPress, width, offset }) => {
  const insets = useSafeAreaInsets();
  const bottomBarStyles = {
    height: insets.bottom + 50,
  };

  return (
    <Animated.View style={[bottomBarStyles, { width }]}>
      <View style={styles.bottomBar}>
        <View style={styles.bottomBarInnerContainer}>
          {showLeft ? (
            <TouchableOpacity
              style={styles.bottomBarButton}
              hitSlop={styles.bottomBarButtonHitSlop}
              onPress={handleLeftPress}
              activeOpacity={0.5}>
              <Image style={styles.buttonBarButtonImage} source={images.Button_Back} />
              <Text style={styles.buttonBarButtonText} allowFontScaling={false}>
                {'Previous day'}
              </Text>
            </TouchableOpacity>
          ) : (
            <View />
          )}
          {showRight ? (
            <TouchableOpacity
              style={styles.bottomBarButton}
              hitSlop={styles.bottomBarButtonHitSlop}
              onPress={handleRightPress}
              activeOpacity={0.5}>
              <Text style={styles.buttonBarButtonText} allowFontScaling={false}>
                {'Next day'}
              </Text>
              <Image style={styles.buttonBarButtonImageRight} source={images.Button_Back} />
            </TouchableOpacity>
          ) : (
            <View />
          )}
        </View>
      </View>
    </Animated.View>
  );
};

const DayScreen = ({ route, navigation }) => {
  const scrollView = useRef(null);
  const moreRef = useRef(null);
  const fontRef = useRef(null);
  const toast = useToast();
  const _state = useNavigationState(state => state);

  const context = useContext(AppContext);
  const { days, dimensions, user } = context;

  const menuWidth = 375;
  const menuOffset = useSharedValue(-menuWidth);
  const screenOffset = useSharedValue(0);
  const menuBackgroundOffset = useSharedValue(0);

  const params = route.params;
  const paramDay = params && params.day;
  const paramIndex = params && params.dayIndex;
  const openServiceSheet = params && params.openServiceSheet;

  const [menuOpen, setMenuOpen] = useState(false);
  const [day, setDay] = useState(paramDay);
  const [index, setIndex] = useState(paramIndex);
  const [showPrevious, setShowPrevious] = useState(true);
  const [showNext, setShowNext] = useState(true);
  const [bookmarked, setBookmarked] = useState(false);
  const [note, setNote] = useState('');
  const [moreOpen, setMoreOpen] = useState(false);
  const [fontOpen, setFontOpen] = useState(false);
  const [moreCollectOpen, setMoreCollectOpen] = useState(false);

  const [serviceType, setServiceType] = useState('continuous');
  const [collectOption, setCollectOption] = useState({ type: 'collect', label: 'Show all', value: 'Show all' });
  const [options, setOptions] = useState([]);
  const [fontMultiplier, setFontMultiplier] = useState(1);

  const [hasAlternatives, setHasAlternatives] = useState(paramDay.alternatives !== undefined);
  const [alternativeIndex, setAlternativeIndex] = useState(paramDay.alternatives ? paramDay.alternatives.indexOf(paramDay.id) : 0);
  const [hasAccess, setHasAccess] = useState(true);

  tagsStyles = {
    p: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 16 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 22 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    a: {
      fontFamily: 'FiraSans-Regular',
      fontSize: 15 * fontMultiplier,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 20 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
      textDecorationLine: 'underline',
    },
    i: {
      fontFamily: 'FiraSans-Italic',
      fontWeight: 'normal',
      fontStyle: Platform.OS === 'ios' ? 'italic' : 'normal',
      color: colors.defaultText,
    },
    b: {
      fontFamily: 'FiraSans-Bold',
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
    },
    h1: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginTop: 16,
      marginBottom: 8,
    },
    h2: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26,
      letterSpacing: -0.1,
      color: colors.defaultText,
      marginTop: 16,
      marginBottom: 8,
    },
    tab: {
      fontFamily: 'FiraSans-Regular',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: 16 * fontMultiplier,
      lineHeight: 22 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.defaultText,
    },
    line: {
      marginBottom: 10,
    }
  };

  classesStyles = {
    biog: {
      marginTop: 8,
    },
    AdditionalLectionary: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 26 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      // marginBottom: 4,
    },
    'plus-S': {
      display: 'none',
    },
    eventReadingHeader: {
      fontFamily: 'FiraSans-Bold',
      fontSize: 18 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
      fontStyle: 'normal',
      lineHeight: 24 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.accentBlack,
      marginBottom: 16,
      overflow: 'visible',
      backgroundColor: colors.transparent,
    },
    passageref: {
      fontFamily: 'FiraSans-SemiBold',
      fontSize: 20 * fontMultiplier,
      fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
      fontStyle: 'normal',
      lineHeight: 28 * fontMultiplier,
      letterSpacing: -0.1,
      color: colors.primary,
      margin: 0,
    }
  }

  useEffect(() => {
    if (openServiceSheet) {
      EventRegister.emit('modal/open-service-sheet');
    }
  }, []);

  useEffect(() => {
    const getCollectType = async () => {
      const collectType = await DataController.getCollects();

      setCollectOption({ type: 'collect', label: collectType, value: collectType });
    };

    getCollectType();
  }, [])

  useEffect(() => {
    if (day.Collect) {
      const array = [{ type: 'collect', label: 'Show all', value: 'Show all' }];

      for (let i = 0; i < day.Collect.length; i++) {
        array.push({ type: 'collect', label: `Collect ${i + 1}`, value: `Collect ${i + 1}` })
      }

      setOptions(array);
    }
  }, [day.id]);

  useEffect(() => {
    const getServiceType = async () => {
      let type = await DataController.getServiceType();

      // console.log('Service type', type);

      if (type === 0) {
        setServiceType('continuous')
      } else if (type === 1) {
        setServiceType('related');
      }
    };

    getServiceType();
  }, []);

  useEffect(() => {
    const saveRecentlyViewed = async () => {
      await DataController.saveRecentlyViewed(day.id);
    };

    saveRecentlyViewed();
  }, [day]);

  useEffect(() => {
    setHasAlternatives(day.alternatives !== undefined);

    if (day.alternatives) {
      setAlternativeIndex(day.alternatives.indexOf(day.id));
    }
  }, [day]);

  useEffect(() => {
    if (days[index - 1] === undefined) {
      setShowPrevious(false);
    } else {
      setShowPrevious(true);
    }

    if (days[index + 1] === undefined) {
      setShowNext(false);
    } else {
      setShowNext(true);
    }
  }, [days, index]);

  const menuButtonPressed = useCallback(
    (value) => {
      menuOffset.value = withTiming(value ? 0 : -menuWidth, {
        duration: 250,
        easing: Easing.inOut(Easing.exp),
      });

      screenOffset.value = withTiming(value ? menuWidth : 0, {
        duration: 250,
        easing: Easing.inOut(Easing.exp),
      });

      setMenuOpen(value);
    },
    [menuOffset, menuWidth, screenOffset],
  );

  const bottomBarOffset = useAnimatedStyle(() => ({
    transform: [{ translateX: screenOffset.value }],
    // alignSelf: 'flex-end',
  }));

  useEffect(() => {
    const toggleServiceType = async (buttonPressed) => {
      if (buttonPressed === 'continuous') {
        !__DEV__ && FirebaseService.logEvent('service_sheet_type_changed', { screen: 'Day', type: 'Continuous (default)' });
        setServiceType('continuous');
        await DataController.saveServiceType(0);
      } else {
        !__DEV__ && FirebaseService.logEvent('service_sheet_type_changed', { screen: 'Day', type: 'Related' });
        setServiceType('related');
        await DataController.saveServiceType(1);
      }
    }

    const toggleCollectOption = async (option) => {

      setCollectOption(option);
      await DataController.saveCollectType(option - 1);
    };

    const changeFontMultiplier = async (addToMultiplier) => {
      const newMultiplier = fontMultiplier + addToMultiplier

      if (newMultiplier < 3.1 && newMultiplier > 0.5) {
        !__DEV__ && FirebaseService.logEvent('font_size_change', { screen: 'Day', change: newMultiplier });
        setFontMultiplier(newMultiplier);
        await DataController.setFontMultiplier(newMultiplier);
      }
    }

    const resetFontMultiplier = async () => {
      !__DEV__ && FirebaseService.logEvent('font_size_change', { screen: 'Day', change: 1 });
      setFontMultiplier(1);
      await DataController.setFontMultiplier(1);
    }

    const getFontMultiplier = async () => {
      const fontMultiplierInStorage = await DataController.getFontMultiplier();
      setFontMultiplier(fontMultiplierInStorage);
    };

    const copyAllText = () => {
      !__DEV__ && FirebaseService.logEvent('day_copy_all_text_pressed');

      let plaintext = '';
      let richtext = '';

      const events = day.Event;
      const readingNotes = day.AdditionReadingNotes;
      const readings = day.Readings;
      const collects = day.Collect;
      const postCommunion = day['Post Communion prayer'];
      const additionalLectionary = day.AdditionalWeekdayLectionary;

      const time = new Date(new Date(day.Date).valueOf());

      // Create header
      richtext += day.WeekTitle ? `<div style="font-size: 1em;">${day.WeekTitle}</div>` : '';
      richtext += day.DayTitle ? `<div>${day.DayTitle}</div>` : '';
      richtext += day.Date ? `<div>${format(parseISO(day.Date), 'EEEE d MMMM yyyy')}</div>` : '';

      plaintext += day.WeekTitle ? day.WeekTitle + '\n' : '';
      plaintext += day.DayTitle ? day.DayTitle + '\n' : '';
      plaintext += day.Date ? format(parseISO(day.Date), 'EEEE d MMMM yyyy') + '\n' : '';

      if (events) {
        for (let i = 0; i < events.length; i++) {
          const event = events[i];

          if (event.data) {
            richtext += `<b>${event.data}${(event.option && DataController.eventShouldShowOption(event.option)) ? ` (${event.option})` : ''}</b>\n\n`;
            plaintext += event.data + `${(event.option && DataController.eventShouldShowOption(event.option)) ? ` (${event.option})` : ''}\n\n`;
          }

          //           ${ event.EventReadings ? '<sup class="eventReadingHeader" >' + event.EventReadings[0].option + '</sup>' + '<line>' + event.EventReadings[0].data.replace(/<i>also<\/i>/gim, '<i>also </i>').replace(/<img src=\'blueArrow.png\' class=\'BibleLinkImage\' \/>/gm, '').replace(/>\s+/gim, '>') + '</line>' : '' }
          // ${ event.EventCollect ? '<h1>Collect</h1>' + event.EventCollect[0].data.replace(/>\s+/gim, '>') : '' }
          // ${ event['Event Post Communion prayer'] ? '<h1>Post Communion Prayer</h1>' + event['Event Post Communion prayer'][0].data.replace(/>\s+/gim, '>') : '' }
          // ${ event['Event biog'] ? '<h1>Biography</h1>' + event['Event biog'][0].data + eventCopyright : '' }

          const eventCollect = event.EventCollect;
          const eventReadings = event.EventReadings;
          const eventPrayer = event['Event Post Communion prayer'];
          const eventBiog = event['Event biog'];

          if (eventReadings) {
            for (let j = 0; j < eventReadings.length; j++) {
              let reading = eventReadings[j];

              const heading = reading.option;
              const headingRichtext = heading.replace(/\n/gm, '<br>');

              richtext += `<br><br><b><u>${headingRichtext}</u></b>`;
              plaintext += `\n${DataController.formatHTMLToPlaintext(heading)}\n\n`;

              let richtextData = reading.data;

              let plaintextData = reading.data
              plaintextData = plaintextData.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
              plaintextData = plaintextData.replace(RegExp("(</a>)", 'g'), "</span>");
              plaintextData = plaintextData.replace(/\n/gm, ' ');

              richtext += `<p>${richtextData}</p>`;
              plaintext += DataController.formatHTMLToPlaintext(plaintextData);
            }
          }

          if (eventCollect) {
            richtext += '<br><br><div><b><i>Collect</i></b>\n</div>'
            plaintext += '\n\nCollect\n\n';

            for (let j = 0; j < eventCollect.length; j++) {
              const collect = eventCollect[j];

              richtext += `<div>${collect.data}</div>`;
              plaintext += DataController.formatHTMLToPlaintext(collect.data);

              if (eventCollect[j + 1] !== undefined) {
                richtext += '\n<b><i>or</i></b>\n'
                plaintext += '\n\nor\n\n';
              }
            }
          }

          if (eventPrayer) {
            richtext += '<br><br><div><b><i>Post Communion Prayer</i></b>\n</div>'
            plaintext += '\n\nPost Communion Prayer\n\n';

            for (let j = 0; j < eventPrayer.length; j++) {
              const prayer = eventPrayer[j];

              richtext += `<div>${prayer.data}</div>`;
              plaintext += DataController.formatHTMLToPlaintext(prayer.data);

              if (eventPrayer[j + 1] !== undefined) {
                richtext += '<br><br>'
                plaintext += '\n\n';
              }
            }
          }

          if (eventBiog) {
            richtext += '<br><br><div><b><i>Biography</i></b>\n</div>'
            plaintext += '\n\nBiography\n\n';

            for (let j = 0; j < eventBiog.length; j++) {
              const biog = eventBiog[j];

              richtext += `<div>${biog.data}</div>`;
              plaintext += DataController.formatHTMLToPlaintext(biog.data);

              if (eventBiog[j + 1] !== undefined) {
                richtext += '<br><br>'
                plaintext += '\n\n';
              }
            }

            const eventCopyright = '<p class=biog>Extract from <i>Saints on Earth: A biographical companion to Common Worship</i> by John H Darch and Stuart K Burns</p>';

            richtext += `${eventCopyright}`;
            plaintext += `\n\n${DataController.formatHTMLToPlaintext(eventCopyright)}`;
          }
        }
      }

      if (readingNotes) {
        richtext += `<br><br><i>Reading Notes: ${readingNotes}</i>`;
        plaintext += `Reading Notes: ${DataController.formatHTMLToPlaintext(readingNotes)}`;
      }

      if (readings) {
        for (let i = 0; i < readings.length; i++) {
          const reading = readings[i];

          richtext += `<br><br><b><u>${reading.option}</u></b>`;
          plaintext += `\n\n${reading.option}\n`;

          let richtextData = reading.data;
          richtextData = richtextData.replace(/\n/gm, '<br>');

          let plaintextData = reading.data
          plaintextData = plaintextData.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
          plaintextData = plaintextData.replace(RegExp("(</a>)", 'g'), "</span>");

          richtext += `<p>${richtextData}</p>`;
          plaintext += DataController.formatHTMLToPlaintext(plaintextData);
        }
      }

      if (collects) {
        richtext += '<br><br><div><b><i>Collect</i></b>\n</div>'
        plaintext += '\nCollect\n\n';

        for (let i = 0; i < collects.length; i++) {
          const collect = collects[i];

          richtext += `<div>${collect.data}</div>`;
          plaintext += DataController.formatHTMLToPlaintext(collect.data);

          if (collects[i + 1] !== undefined) {
            richtext += '\n<b><i>or</i></b>\n'
            plaintext += '\n\nor\n\n';
          }
        }
      }

      if (postCommunionPrayer) {
        richtext += '<br><br><div><b><i>Post Communion Prayer</i></b>\n</div>'
        plaintext += '\n\nPost Communion Prayer\n\n';

        for (let i = 0; i < postCommunion.length; i++) {
          const prayer = postCommunion[i];

          richtext += `<div>${prayer.data}</div>`;
          plaintext += DataController.formatHTMLToPlaintext(prayer.data);

          if (postCommunion[i + 1] !== undefined) {
            richtext += '<br><br>'
            plaintext += '\n\n';
          }
        }
      }

      if (additionalLectionary) {
        richtext += '<br><br><div><b><i>Additional Weekday Lectionary</i></b>\n</div>'
        plaintext += '\n\nAdditional Weekday Lectionary\n\n';

        for (let i = 0; i < additionalLectionary.length; i++) {
          const additional = additionalLectionary[i];

          const data = additional.data
          data = data.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
          data = data.replace(RegExp("(</a>)", 'g'), "</span>");

          richtext += `<div>${data}</div>`;
          plaintext += DataController.formatHTMLToPlaintext(data);

          if (additionalLectionary[i + 1] !== undefined) {
            richtext += '<br><br>'
            plaintext += '\n\n';
          }
        }
      }

      if (note !== '') {
        richtext += '<br><div><b><i>Notes</i></b>\n</div>'
        plaintext += '\n\nNotes\n\n';

        richtext += `<p>${note}</p>`;
        plaintext += note;
      }

      plaintext += "\n\nShared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.";
      richtext += "<br><div style='font-size: smaller;font-style: italic'>Shared from the Lectionary app. Material subject to copyright. Please visit the About this App page for further information.</div>";

      // TODO: web sharing
      if (Platform.OS === 'web') {
        const blobHTML = new Blob([richtext], { type: 'text/html' });
        const blobPlain = new Blob([plaintext], { type: 'text/plain' });
        const clipboardItem = new ClipboardItem({ 'text/html': blobHTML, 'text/plain': blobPlain });

        navigator.clipboard.write([clipboardItem]);
      } else {
        Clipboard.setString(plaintext);
      }

      toast.show('All text copied', { id: Date.now(), style: { zIndex: 1000000 } });
    };

    const sharingOptions = () => {
      !__DEV__ && FirebaseService.logEvent('day_sharing_options_pressed');

      let plaintext = '';

      const time = new Date(new Date(day.Date).valueOf());

      plaintext += 'Here is the Lectionary entry for:\n';
      plaintext += day.WeekTitle ? day.WeekTitle + '\n' : '';
      plaintext += day.DayTitle ? day.DayTitle + '\n' : '';
      plaintext += day.Date ? format(parseISO(day.Date), 'EEEE d MMMM yyyy') + '\n' : '';

      const readings = day.Readings;

      if (readings) {
        for (let i = 0; i < readings.length; i++) {
          const reading = readings[i];

          plaintext += `\n\n${reading.option}\n`;

          let plaintextData = reading.data
          plaintextData = plaintextData.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
          plaintextData = plaintextData.replace(RegExp("(</a>)", 'g'), "</span>");

          plaintext += DataController.formatHTMLToPlaintext(plaintextData);
        }
      }

      plaintext += "\n\nFind out more about the Lectionary app at:\nhttps://www.chpublishing.co.uk/apps/common-worship-lectionary";

      if (Platform.OS === 'web') {
        const blobPlain = new Blob([plaintext], { type: 'text/plain' });
        const clipboardItem = new ClipboardItem({ 'text/plain': blobPlain });

        navigator.clipboard.write([clipboardItem]);
      } else {
        Share.open({
          title: 'Lectionary',
          message: plaintext,
          url: 'https://www.chpublishing.co.uk/apps/common-worship-lectionary'
        })
      }
    };

    const exportToCalendar = async () => {
      let plaintext = '';

      const time = new Date(new Date(day.Date).valueOf());

      plaintext += day.WeekTitle ? day.WeekTitle + '\n' : '';
      plaintext += day.DayTitle ? day.DayTitle + '\n' : '';
      plaintext += day.Date ? format(parseISO(day.Date), 'EEEE d MMMM yyyy') + '\n' : '';

      const readings = day.Readings;

      if (readings) {
        for (let i = 0; i < readings.length; i++) {
          const reading = readings[i];

          plaintext += `\n\n${reading.option}\n`;

          let plaintextData = reading.data
          plaintextData = plaintextData.replace(RegExp("(<a.*?>)", 'g'), '<span style="padding-left:20px;font-weight:bold">');
          plaintextData = plaintextData.replace(RegExp("(</a>)", 'g'), "</span>");

          plaintext += DataController.formatHTMLToPlaintext(plaintextData);
        }
      }

      plaintext += "\n\nFind out more about the Lectionary app at:\nhttps://www.chpublishing.co.uk/apps/common-worship-lectionary";

      try {
        const title = `Lectionary for ${format(parseISO(day.Date), 'EEEE d MMMM yyyy')}`;

        let permissions = await RNCalendarEvents.checkPermissions();

        if (permissions !== 'authorized') {
          permissions = await RNCalendarEvents.requestPermissions();
        }

        if (permissions === 'authorized') {
          const event = await RNCalendarEvents.saveEvent(title, {
            startDate: day.Date ? new Date(day.Date).toISOString() : new Date().toISOString(),
            endDate: day.Date ? new Date(day.Date).toISOString() : new Date().toISOString(),
            notes: plaintext,
            allDay: true,

          });

          __DEV__ && console.log(event);

          toast.show('Event created', { id: Date.now(), style: { zIndex: 999999 } });
        } else {
          toast.show('Permissions rejected', { id: Date.now(), style: { zIndex: 999999 } });
        }
      } catch (error) {
        console.log(error);

        toast.show('Failed to create event', { id: Date.now(), style: { zIndex: 999999 } });
      }
    };

    // const goBack = () => {
    //   navigation.goBack();
    //   return;

    //   if (navigation.canGoBack()) {
    //     navigation.goBack();
    //   } else {
    //     navigation.dispatch(CommonActions.reset({
    //       routes: [
    //         { name: 'Dashboard' },
    //         { name: 'Day' },
    //       ],
    //       index: 1,
    //     }));
    //   }
    // };

    navigation.setOptions({
      headerTitle: '',
      headerLeft: () => (
        <View style={styles.headerRow}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <Image style={styles.menuIcon} source={images.Button_Back} />
            <Text style={styles.backButtonText} allowFontScaling={false}>
              {'Back'}
            </Text>
          </TouchableOpacity>
        </View>
      ),
      headerRight: () => (
        <View style={styles.headerRow}>
          <TouchableOpacity style={styles.buttonMenu} onPress={() => notesPressed()}>
            <Image
              style={styles.menuIcon}
              source={note === '' ? images.Button_Notes_Inactive : images.Button_Notes_Active}
            />
          </TouchableOpacity>
          <TouchableOpacity style={styles.buttonMenu} onPress={() => bookmarkPressed()}>
            <Image style={styles.menuIcon} source={bookmarked ? images.Button_Bookmark_Active : images.Button_Bookmark_Inactive} />
          </TouchableOpacity>
          <Popover
            popoverStyle={{
              borderRadius: 8,
            }}
            placement={PopoverPlacement.BOTTOM}
            onRequestClose={() => {
              setMoreCollectOpen(false)
            }}
            from={(
              <TouchableOpacity style={styles.buttonMenu} onPress={() => fontOptionsPressed()}>
                <Image style={styles.menuIcon} source={images.Button_Settings} />
              </TouchableOpacity>
            )}>
            <View style={styles.popoverContainer}>
              <Text style={styles.popoverTitleText}>{'Adjust font size'}</Text>
              <View style={styles.popoverFontButtonsContainerOuter}>
                <View style={styles.popoverFontButtonsContainer}>
                  <TouchableOpacity
                    style={styles.popoverFontDecreaseButton}
                    onPress={() => {
                      changeFontMultiplier(-0.1)
                    }}>
                    <Image style={styles.popoverFontButtonImage} source={images.Button_Decrease} />
                  </TouchableOpacity>
                  <View style={{ height: 44, width: 77, justifyContent: 'center', borderColor: colors.grey40, borderLeftWidth: 1, borderRightWidth: 1, alignItems: 'center' }}>
                    <Text style={styles.popoverFontText}>{(fontMultiplier * 100).toFixed(0) + '%'}</Text>
                  </View>
                  <TouchableOpacity
                    style={styles.popoverFontIncreaseButton}
                    onPress={() => {
                      changeFontMultiplier(0.1)
                    }}>
                    <Image style={styles.popoverFontButtonImage} source={images.Button_Increase} />
                  </TouchableOpacity>
                </View>
                {(fontMultiplier * 100).toFixed(0) !== '100' && (
                  <View style={styles.resetButtonContainer}>
                    <TouchableOpacity style={styles.resetButton} onPress={() => resetFontMultiplier()}>
                      <Text style={styles.resetButtonText} allowFontScaling={false}>
                        {'Reset'}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </View>
              <Text style={styles.popoverTitleText}>
                {'Select Service Sheet type'}
              </Text>
              <View style={styles.popoverToggleContainer}>
                <TouchableOpacity style={[serviceType == 'continuous' ? styles.popoverToggleActive : styles.popoverToggleInactive]} onPress={() => toggleServiceType('continuous')}>
                  <Text style={serviceType == 'continuous' ? styles.popoverToggleActiveText : styles.popoverToggleInactiveText}>{'Continuous'}</Text>
                </TouchableOpacity>
                <TouchableOpacity style={[serviceType == 'related' ? styles.popoverToggleActive : styles.popoverToggleInactive]} onPress={() => toggleServiceType('related')}>
                  <Text style={serviceType == 'related' ? styles.popoverToggleActiveText : styles.popoverToggleInactiveText}>{'Related'}</Text>
                </TouchableOpacity>
              </View>
              {day.Collect?.length > 1 ?
                <View style={{ overflow: 'visible', zIndex: 10, maxWidth: Platform.OS === 'web' ? 280 : 259 }}>
                  <Text style={styles.popoverTitleText}>
                    {'Select Collect option'}
                  </Text>

                  <View style={{ zIndex: 1000, width: '100%' }}>
                    <DropDownPicker
                      open={moreCollectOpen}
                      setOpen={setMoreCollectOpen}
                      items={options}
                      value={collectOption}
                      setValue={setCollectOption}
                      zIndex={10000}
                      zIndexInverse={-10000}
                      placeholder={collectOption ? collectOption.value : ''}
                      onSelectItem={onSelectItem}
                      showTickIcon={true}
                      activeLabelStyle={{ color: 'red' }}
                      style={{
                        backgroundColor: colors.accentWhite,
                        borderColor: colors.grey40,
                        borderWidth: 1,
                        borderRadius: 4,
                        height: 44,
                        zIndex: 10000
                      }}
                      textStyle={{
                        fontFamily: 'FiraSans-SemiBold',
                        fontSize: 17,
                        fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                        fontStyle: 'normal',
                        letterSpacing: 0.1,
                        color: colors.defaultText,
                      }}
                      itemProps={{
                        activeOpacity: 0.6,
                        style: {
                          height: 44,
                          alignItems: 'center',
                          flexDirection: 'row',
                          paddingHorizontal: 8,
                        }
                      }}
                      labelStyle={{
                        fontFamily: 'FiraSans-SemiBold',
                        fontSize: 17,
                        fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                        fontStyle: 'normal',
                        letterSpacing: 0.1,
                        color: colors.defaultText,
                        lineHeight: 44,
                      }}
                      labelProps={{
                        numberOfLines: 1,
                        height: 44,
                      }}
                      placeholderStyle={{
                        fontFamily: 'FiraSans-SemiBold',
                        fontSize: 17,
                        fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
                        fontStyle: 'normal',
                        lineHeight: 44,
                        letterSpacing: 0.1,
                        color: colors.defaultText,
                        alignSelf: 'center',
                      }}
                      dropDownContainerStyle={{
                        borderColor: colors.grey40,
                        borderWidth: 1,
                        borderTopWidth: 1,
                        borderBottomStartRadius: 4,
                        borderBottomEndRadius: 4,
                        position: 'absolute',
                        zIndex: 10000,
                      }}
                      ArrowDownIconComponent={() => (
                        <Image
                          source={images.Button_Collapse_Red}
                          style={{ height: 44, width: 44, marginEnd: -8 }}
                        />
                      )}
                      ArrowUpIconComponent={() => (
                        <Image
                          source={images.Button_Collapse_Red}
                          style={{ height: 44, width: 44, marginEnd: -8, transform: [{ rotateX: '180deg' }] }}
                        />
                      )}
                      flatListProps={{
                        ItemSeparatorComponent: () => <View style={{ height: 1, backgroundColor: colors.grey40 }} />
                      }}
                      activeItemStyle={{ backgroundColor: '#dfdfdf' }}
                      tickIconContainerStyle={{
                        backgroundColor: colors.grey40
                      }}
                    />
                  </View>

                  {/* <View style={styles.popoverToggleContainer}>
                    <TouchableOpacity
                      style={[collectOption == 1 ? styles.popoverToggleActive : styles.popoverToggleInactive]}
                      onPress={() => toggleCollectOption(1)}>
                      <Text
                        style={collectOption == 1 ? styles.popoverToggleActiveText : styles.popoverToggleInactiveText}>
                        {'Collect 1'}
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[collectOption == 2 ? styles.popoverToggleActive : styles.popoverToggleInactive]}
                      onPress={() => toggleCollectOption(2)}>
                      <Text
                        style={collectOption == 2 ? styles.popoverToggleActiveText : styles.popoverToggleInactiveText}>
                        {'Collect 2'}
                      </Text>
                    </TouchableOpacity>
                    <CollectOptions
                      day={day}
                      collectOption={collectOption}
                      allCollects={day.Collect}
                    />
                  </View> */}
                </View>
                : null}
              <View style={[styles.popoverButtonsContainer, { marginTop: 16, zIndex: 1 }]}>
                <TouchableOpacity style={styles.popoverButton} onPress={() => copyAllText()}>
                  <Image
                    style={{ width: 44, height: 44, marginEnd: -10 }}
                    source={images.Button_Copy_Grey}
                  />
                  <Text style={styles.popoverButtonText}>
                    {'Copy all text'}
                  </Text>
                </TouchableOpacity>
                <PopoverSeparator />
                {Platform.OS !== 'web' && (
                  <TouchableOpacity style={styles.popoverButton} onPress={() => sharingOptions()}>
                    <Image
                      style={{ width: 44, height: 44, marginEnd: -10 }}
                      source={images.Button_Share}
                    />
                    <Text style={styles.popoverButtonText}>
                      {'View sharing options'}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
              {/* <View style={[styles.popoverButtonsContainer, { marginTop: 16, zIndex: 1 }]}>
                <TouchableOpacity style={styles.popoverButton} onPress={() => exportToCalendar()}>
                  <Text style={styles.popoverButtonText}>
                    {'Export to calendar'}
                  </Text>
                </TouchableOpacity>
              </View> */}
            </View>
          </Popover>
        </View>
      ),
      headerStyle: {
        backgroundColor: colors.grey20,
        shadowRadius: 0,
        shadowOffset: {
          height: 0,
        },
        borderBottomWidth: 0.5,
        borderBottomColor: colors.grey50,
        height: Platform.OS === 'web' ? 44 : undefined,
      },
    });
  }, [
    bookmarkPressed,
    notesPressed,
    fontOptionsPressed,
    menuButtonPressed,
    menuOpen,
    morePressed,
    navigation,
    bookmarked,
    serviceType,
    collectOption,
    onSelectItem,
    fontMultiplier,
    note,
    day,
    moreCollectOpen,
    setMoreCollectOpen,
    options,
    collectOption,
    setCollectOption,
    onSelectItem,
  ]);

  // useFocusEffect(
  //   useCallback(() => {
  //     const insertBeforeLast = (routeName, params) => (state) => {
  //       const routes = [
  //         ...state.routes.slice(0, -1),
  //         { name: routeName, params },
  //         state.routes[state.routes.length - 1],
  //       ];

  //       console.log('inside', _state);
  //       console.log('inside', navigation.canGoBack());

  //       return CommonActions.reset({
  //         ...state,
  //         routes,
  //         index: routes.length - 1,
  //       });
  //     };

  //     RootNavigation.navigationRef.current?.dispatch(insertBeforeLast('Dashboard'));
  //   }, [navigation])
  // );

  useEffect(() => {
    getBookmarks();
    getNote();
  }, []);

  useEffect(() => {
    getBookmarks();
    getNote();
  }, [day.id,]);

  useEffect(() => {
    getFontMultiplier();
  }, [])

  useEffect(() => {
    EventRegister.addEventListener('bookmarks/updated', getBookmarks);
    EventRegister.addEventListener('notes/updated', getNote);
    EventRegister.addEventListener('setting/collect-type-changed', async () => {
      const type = await DataController.getCollects();
      setCollectOption({ type: 'collect', label: type, value: type });
    });
    EventRegister.addEventListener('no-access/go-back', noAccessGoBack);
    EventRegister.addEventListener('subscriptions/open-accounts', () => {
      navigation.replace('Subscriptions');
    });

    return () => {
      EventRegister.removeEventListener('bookmarks/updated');
      EventRegister.removeEventListener('notes/updated');
      EventRegister.removeEventListener('setting/collect-type-changed');
      EventRegister.removeEventListener('subscriptions/open-accounts');
      EventRegister.removeEventListener('no-access/go-back');
    };
  }, [navigation]);

  useEffect(() => {
    const checkUserHasAccess = async () => {
      const hymnsSub = await DataController.getHymnsSubscription();
      const appSub = await DataController.getCurrentSubscription();
      const expiry = await DataController.getExpiryDate();
      const trialData = await AuthenticationController.getFreeTrialData();
      let trialEnd;

      if (trialData) {
        trialEnd = new Date(trialData.TrialEndDate);
      }

      if (trialEnd) {
        if (IAPController.checkTrialIsActive(trialEnd)) {
          // __DEV__ && console.log('trial')
          setHasAccess(true);
        } else if (hymnsSub && appSub) {
          __DEV__ && console.log('both');
          const latest = IAPController.getMoreRecentSubscription(hymnsSub, appSub, expiry);

          __DEV__ && console.log('trial end both - latest.type', latest.type);

          if (latest.type === 'hymns') {
            const valid = await IAPController.checkHymnsSubscriptionIsValid(hymnsSub);
            setHasAccess(valid);
          } else if (latest.type === 'app') {
            const valid = await IAPController.checkAppSubscriptionIsValid(appSub, expiry);
            setHasAccess(valid);
          }
        } else if (hymnsSub) {
          __DEV__ && console.log('hymns');
          __DEV__ && console.log(hymnsSub);
          const valid = await IAPController.checkHymnsSubscriptionIsValid(hymnsSub);
          __DEV__ && console.log(valid);
          setHasAccess(valid);
        } else if (appSub) {
          __DEV__ && console.log('appSub')
          const valid = await IAPController.checkAppSubscriptionIsValid(appSub, expiry);
          setHasAccess(valid);
        } else {
          __DEV__ && console.log('trialEnd')
          setHasAccess(false);
        }
      } else {
        if (hymnsSub && appSub) {
          __DEV__ && console.log('hymnsSub', hymnsSub)
          __DEV__ && console.log('appSub', appSub)
          const latest = IAPController.getMoreRecentSubscription(hymnsSub, appSub, expiry);
          __DEV__ && console.log('trial active - latest.type', latest.type);

          if (latest.type === 'hymns') {
            const valid = await IAPController.checkHymnsSubscriptionIsValid(hymnsSub);
            setHasAccess(valid);
          } else if (latest.type === 'app') {
            const valid = await IAPController.checkAppSubscriptionIsValid(appSub, expiry);
            setHasAccess(valid);
          }
        } else if (hymnsSub) {
          const valid = await IAPController.checkHymnsSubscriptionIsValid(hymnsSub);
          setHasAccess(valid);
        } else if (appSub) {
          const valid = await IAPController.checkAppSubscriptionIsValid(appSub, expiry);
          setHasAccess(valid);
        } else {
          setHasAccess(false);
        }
      }
    };

    if (Platform.OS !== 'web') {
      checkUserHasAccess();

      checkAccessInterval = setInterval(() => {
        checkUserHasAccess();
      }, 10000);
    }

    return () => {
      try {
        if (Platform.OS !== 'web') {
          clearInterval(checkAccessInterval);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, []);

  const noAccessGoBack = () => {
    try {
      navigation.goBack();
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectItem = useCallback(async (item) => {
    !__DEV__ && FirebaseService.logEvent('collect_option_changed', { option: item.value });

    __DEV__ && console.log(item);
    await DataController.saveCollects(item.value);
    setCollectOption(item);
    setMoreCollectOpen(false);
  }, []);

  const notesPressed = useCallback(() => {
    !__DEV__ && FirebaseService.logEvent('day_notes_pressed', { date: day.Date });

    EventRegister.emit('notes/open-notes');
  }, [toast]);

  const bookmarkPressed = useCallback(async () => {
    if (user) {
      await DatabaseService.updateBookmark(user.email, user.requestToken, day.id);
    }

    await DataController.addBookmark(day.id, day.Date);
    EventRegister.emit('bookmarks/updated');
  }, [day.id]);

  const fontOptionsPressed = useCallback(() => {
    toast.show('TBC', { id: Date.now() });
  }, [toast]);

  const morePressed = useCallback(() => {
    setMoreOpen(true);
    // toast.show('Text copied', {
    //   id: 1,
    //   icon: (
    //     <Image source={images.Button_Copy} />
    //   ),
    //   style: {
    //     padding: 0,
    //     backgroundColor: colors.accentWhite,
    //     height: 44,
    //     width: dimensions.window.width - 50,
    //     maxWidth: 325,
    //     borderRadius: 4,
    //     justifyContent: 'center',
    //   },
    //   textStyle: {
    //     fontFamily: 'FiraSans-SemiBold',
    //     fontSize: 17,
    //     fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    //     fontStyle: 'normal',
    //     letterSpacing: -0.1,
    //     textAlign: 'center',
    //     color: colors.primary,
    //     marginLeft: -10,
    //   }
    // })
  }, [toast]);

  let width;

  const getFontMultiplier = async () => {
    const fontMultiplierInStorage = await DataController.getFontMultiplier();
    setFontMultiplier(fontMultiplierInStorage);
  };

  const getBookmarks = async () => {
    const _bookmarks = await DataController.getBookmarks();

    // console.log(_bookmarks);

    if (_bookmarks.includes(day.id)) {
      setBookmarked(true);
    } else {
      setBookmarked(false);
    }
  };

  const getNote = async () => {
    const _note = await DataController.getNote(day.id);
    // console.log('_note', day.id, _note);

    if (_note) {
      setNote(_note.note);
    } else {
      setNote('');
    }
  };

  const handleLeftPress = () => {
    // EventRegister.emit('day/close-dropdowns');

    setTimeout(() => {
      try {
        !__DEV__ && FirebaseService.logEvent('day_previous_pressed');
        setIndex(index - 1);
        setDay(days[index - 1]);
        scrollView.current?.scrollToPosition(0, 0, true);
      } catch (error) {
        console.log(error);
      }
    }, 200);
  };

  const handleRightPress = () => {
    // EventRegister.emit('day/close-dropdowns');

    setTimeout(() => {
      try {
        !__DEV__ && FirebaseService.logEvent('day_next_pressed');
        setIndex(index + 1);
        setDay(days[index + 1]);
        scrollView.current?.scrollToPosition(0, 0, true);
      } catch (error) {
        console.log(error);
      }
    }, 200);
  };

  if (!(isTablet() || Platform.OS === 'web')) {
    width = '100%';
  } else {
    width = menuOpen ? context.dimensions.window.width - menuWidth : '100%';
  }

  const postCommunionPrayer = day['Post Communion prayer'] !== undefined;
  const collect = day.Collect !== undefined;
  const event = day.Event;
  const additionalLectionary = day.AdditionalWeekdayLectionary;

  const alternativeChanged = (event) => {
    // EventRegister.emit('day/close-dropdowns');

    !__DEV__ && FirebaseService.logEvent('day_alternative_pressed', { date: day.Date, option: event.nativeEvent.selectedSegmentIndex });

    const selectedIndex = event.nativeEvent.selectedSegmentIndex;
    const alternative = day.alternatives[selectedIndex];

    const _day = days.find((item) => item.id === alternative);
    const _dayIndex = days.findIndex((item) => item.id === _day.id)

    setTimeout(() => {
      try {
        setIndex(_dayIndex);
        setDay(_day);
        scrollView.current?.scrollToPosition(0, 0, true);
      } catch (error) {
        console.log(error);
      }
    }, 300);

    setAlternativeIndex(selectedIndex);
  };

  return (
    <View style={styles.container}>
      {(Platform.OS !== 'web' && !hasAccess) && (
        <NoAccessModal />
      )}
      <KeyboardAwareScrollView
        ref={scrollView}
        extraScrollHeight={128}
        enableOnAndroid
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={[styles.scrollViewContainer, {
          paddingTop: hasAlternatives ? 0 : 15,
          paddingHorizontal: hasAlternatives ? 0 : isTablet() || Platform.OS === 'web' ? 30 : 15,
          paddingBottom: 54,
     }]}>
        {hasAlternatives && (
          <View
            style={{
              width: '100%',
              height: 50,
              backgroundColor: colors.grey30,
              shadowColor: colors.grey50,
              shadowOffset: {
                width: 0,
                height: -0.5,
              },
              shadowRadius: 0,
              shadowOpacity: 1,
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <View
              style={{
                width: '100%',
                maxWidth: 528,
                paddingHorizontal: 28,
              }}>
              <SegmentedControl
                values={day.alternatives && day.alternatives.map((item, index) => `Alternative ${index + 1}`)}
                tintColor={colors.accentWhite}
                backgroundColor="rgba(118, 118, 128, 0.12)"
                appearance="light"
                selectedIndex={alternativeIndex}
                fontStyle={{
                  color: colors.accentBlack,
                  fontSize: 13,
                }}
                onChange={(event) => alternativeChanged(event)}
              />
            </View>
          </View>
        )}
        <View
          style={[styles.innerContainer, {
            paddingTop: hasAlternatives ? 15 : 0,
            paddingHorizontal: !hasAlternatives ? 0 : isTablet() || Platform.OS === 'web' ? 30 : 15,
          }]}>
          <Header
            day={day}
            fontMultiplier={fontMultiplier}
          />
          {event && (
            <Events
              events={event}
              fontMultiplier={fontMultiplier}
            />
          )}
          <Readings
            day={day}
            readings={day.Readings}
            notes={day.AdditionReadingNotes}
            fontMultiplier={fontMultiplier}
            serviceType={serviceType}
          />
          {collect && (
            <Collect
              day={day}
              dimensions={dimensions}
              changeCollect={() => setCollectOption(collectOption === 1 ? 2 : 1)}
              canEdit={day.Collect.length > 1}
              collectOption={collectOption}
              allCollects={day.Collect}
              collect={day.Collect.length > 1 ? collectOption == 1 ? day.Collect[0] : day.Collect[1] : day.Collect[0]}
              fontMultiplier={fontMultiplier}
            />
          )}
          {postCommunionPrayer && (
            <PostCommunionPrayer
              prayer={day['Post Communion prayer'][0]}
              fontMultiplier={fontMultiplier}
            />
          )}
          {additionalLectionary && (
            <AdditionalWeekdayLectionary
              reading={additionalLectionary[0]}
              fontMultiplier={fontMultiplier}
            />
          )}
          <Notes
            day={day}
            initialNote={note}
            fontMultiplier={fontMultiplier}
          />
        </View>
      </KeyboardAwareScrollView>
      <BottomBar
        showLeft={showPrevious}
        showRight={showNext}
        handleLeftPress={handleLeftPress}
        handleRightPress={handleRightPress}
        offset={bottomBarOffset}
        width={width}
      />
      <MorePopover
        visible={moreOpen}
        moreRef={moreRef}
        closePopover={() => setMoreOpen(false)}
        copyAllText={() => notesPressed()}
        generateServiceSheet={() => notesPressed()}
        sharingOptions={() => notesPressed()}
      />
      {Platform.OS === 'ios' && (
        <InputAccessoryView nativeID={'doneToolbarID'}>
          <View style={styles.hideKeyboardContainer}>
            <TouchableOpacity
              onPress={() => Keyboard.dismiss()}
              style={styles.hideKeyboardButton}>
              <Text
                allowFontScaling={false}
                style={styles.hideKeyboardText}>
                {'Hide keyboard'}
              </Text>
            </TouchableOpacity>
          </View>
        </InputAccessoryView>
      )}
    </View>
  );
};

const MorePopover = ({ visible, moreRef, closePopover, copyAllText, generateServiceSheet, sharingOptions }) => {
  return (
    <Popover
      isVisible={visible}
      from={moreRef}
      onRequestClose={() => closePopover()}>
      <View style={styles.popoverContainer}>
        <Text style={styles.popoverTitleText}>{'Options'}</Text>
        <View style={styles.popoverButtonsContainer}>
          <TouchableOpacity style={styles.popoverButton} onPress={() => copyAllText()}>
            <Text style={styles.popoverButtonText}>{'Copy all text'}</Text>
          </TouchableOpacity>
          <PopoverSeparator />
          <TouchableOpacity style={styles.popoverButton} onPress={() => generateServiceSheet()}>
            <Text style={styles.popoverButtonText}>{'Generate Service sheet'}</Text>
          </TouchableOpacity>
          <PopoverSeparator />
          <TouchableOpacity style={styles.popoverButton} onPress={() => sharingOptions()}>
            <Text style={styles.popoverButtonText}>{'Sharing options'}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Popover>
  )
};

const PopoverSeparator = () => <View style={styles.popoverSeparator} />;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.accentWhite,
    flex: 1,
  },
  scrollViewContainer: {
    paddingTop: 15,
    paddingHorizontal: isTablet() || Platform.OS === 'web' ? 30 : 15,
    paddingBottom: 54,
    alignItems: 'center',
  },
  innerContainer: {
    width: '100%',
    maxWidth: 1400,
  },
  headerRow: {
    flexDirection: 'row',
  },
  backButton: {
    flexDirection: 'row',
    marginStart: 4,
    alignItems: 'center',
  },
  backButtonText: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    color: colors.primary,
    marginStart: -5,
  },
  buttonMenu: {
    width: 44,
    height: 44,
    marginStart: 4,
  },
  menuIcon: {
    width: 44,
    height: 44,
    tintColor: colors.primary,
  },
  headerContainer: {
    height: 45,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerIcon: {
    height: 44,
    width: 44,
    marginStart: -8,
    marginEnd: 5.5,
  },
  headerTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.primary,
    textAlign: 'center',
  },
  headerSeparator: {
    height: 2,
    backgroundColor: colors.primary,
    marginStart: isTablet() || Platform.OS === 'web' ? 0 : 41,
    marginTop: 3,
  },
  optionButton: {
    flex: 1,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
  },
  optionText: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: -0.1,
    color: colors.red,
  },
  a: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: -0.1,
    color: colors.defaultText,
    textDecorationLine: 'underline',
    marginBottom: 10,
  },
  readingsContainer: {
    marginTop: 15,
    marginBottom: 5.5,
    flex: 1,
  },
  readingsSeparator: {
    height: 2,
    backgroundColor: colors.red,
  },
  readingContainer: {
    flex: 1,
  },
  header: {
    marginBottom: 15,
  },
  serviceContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    // marginTop: 15,
  },
  weekTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0,
    color: colors.defaultText,
    marginBottom: 5,
  },
  date: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 28,
    letterSpacing: -0.1,
    color: colors.defaultText,
  },
  dayTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginTop: 5,
  },
  colorContainer: {
    borderRadius: 9,
    backgroundColor: '#009900',
    flex: -1,
    height: 16,
    paddingHorizontal: 6,
    justifyContent: 'center',
  },
  eventColorContainer: {
    borderRadius: 9,
    backgroundColor: colors.accentWhite,
    flex: -1,
    height: 16,
    paddingHorizontal: 6,
    justifyContent: 'center',
  },
  colorText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0.1,
    color: colors.accentWhite,
  },
  eventColorText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0.1,
    color: colors.accentBlack,
  },
  notesContainer: {
    marginTop: 15,
  },
  dropdown: {
    minHeight: 44,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: colors.grey30,
    borderWidth: 1,
    borderColor: colors.grey40,
  },
  dropdownIcon: {
    width: 44,
    height: 44,
    tintColor: colors.primary,
  },
  dropdownLabel: {
    flex: 1,
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginStart: -5,
    paddingVertical: 10,
    marginEnd: 8,
  },
  noDropdownLabel: {
    flex: 1,
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginHorizontal: 18,
    paddingTop: 12,
    paddingBottom: 10,
  },
  dropdownContainer: {
    borderColor: colors.grey40,
    backgroundColor: colors.accentWhite,
    borderBottomStartRadius: 4,
    borderBottomEndRadius: 4,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingHorizontal: 15,
    paddingTop: 12,
    paddingBottom: 10,
  },
  notesInput: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 22,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginBottom: 10,
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  bottomBar: {
    height: 50,
    width: '100%',
    borderTopColor: colors.grey30,
    borderTopWidth: 2,
    overflow: 'visible',
  },
  bottomBarInnerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1400,
    alignSelf: 'center',
  },
  bottomBarButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bottomBarButtonHitSlop: {
    left: 16,
    right: 16,
  },
  buttonBarButtonText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.4,
    color: colors.primary,
  },
  buttonBarButtonImage: {
    height: 44,
    width: 44,
  },
  buttonBarButtonImageRight: {
    height: 44,
    width: 44,
    transform: [{ rotate: '180deg' }],
  },
  modalHeader: {
    height: 44,
    backgroundColor: colors.grey20,
    flexDirection: 'row',
    paddingHorizontal: 5,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: colors.grey50,
  },
  modalHeaderRight: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
  },
  buttonPadding: {
    marginEnd: 5,
  },
  bibleScrollViewContainer: {
    paddingTop: 10,
    paddingHorizontal: isTablet() || Platform.OS === 'web' ? 30 : 15,
    paddingBottom: Platform.OS === 'web' ? 64 : 32,
    width: '100%',
    maxWidth: 1400,
    alignSelf: 'center',
  },
  sundayWorshipHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  generateButton: {
    width: 184,
    height: 30,
    borderRadius: 8,
    backgroundColor: colors.grey30,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  generateText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.primary,
  },
  sundayWorshipLogoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '50%'
  },
  sundayWorshipLogo: {
    width: 44,
    height: 44,
    marginStart: -8,
  },
  sundayWorshipHeaderText: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.red,
  },
  sundayWorshipSeparator: {
    height: 2,
    backgroundColor: colors.sundayWorship,
  },
  sundayWorshipDayHeader: {
    paddingTop: 16,
  },
  passageref: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 28,
    letterSpacing: -0.1,
    color: colors.primary,
    margin: 0,
  },
  ww: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 12,
    letterSpacing: -0.06,
    color: colors.defaultText,
    textAlignVertical: 'top',
    marginHorizontal: 3,
  },
  uu: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 12,
    letterSpacing: -0.06,
    color: colors.defaultText,
    textAlignVertical: 'top',
    marginEnd: 3,
  },
  eventContainer: {
    marginTop: -10,
    marginBottom: 15,
  },
  eventReadingHeader: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 18,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.accentBlack,
    backgroundColor: colors.transparent,
    overflow: 'visible',
  },
  morePopoverContainer: {
    borderRadius: 8,
    backgroundColor: colors.grey20,
  },
  popoverContainer: {
    backgroundColor: colors.grey20,
    borderRadius: 8,
    paddingHorizontal: 10,
    paddingBottom: 16,
    overflow: 'visible',
  },
  popoverFontButtonsContainerOuter: {
    backgroundColor: colors.accentWhite,
    borderColor: colors.grey40,
    borderWidth: 1,
    borderRadius: 4,
  },
  popoverFontButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    height: 44,
  },
  resetButtonContainer: {
    borderTopColor: colors.grey40,
    borderTopWidth: 1,
  },
  resetButton: {
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
  },
  resetButtonText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.defaultText,
  },
  popoverFontDecreaseButton: {
    // alignItems: 'center'
  },
  popoverFontIncreaseButton: {
    // alignItems: 'center'
  },
  popoverFontButtonImage: {
    width: 44,
    height: 44
  },
  popoverFontText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 16,
    color: colors.grey70,
    paddingLeft: 10,
    paddingRight: 10
  },
  popoverTitleText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    letterSpacing: -0.1,
    lineHeight: 24,
    color: colors.grey70,
    marginTop: 10,
    marginBottom: 8,
  },
  popoverButtonsContainer: {
    backgroundColor: colors.accentWhite,
    width: 260,
    borderRadius: 4,
    borderColor: colors.grey40,
    borderWidth: 1,
  },
  popoverToggleContainer: {
    flexDirection: 'row',
    height: 44,
    borderRadius: 8,
    overflow: 'hidden',
    padding: 3,
    backgroundColor: '#E6E6E6'
  },
  popoverToggleActive: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 7,
    backgroundColor: '#FFFFFF',
  },
  popoverToggleActiveText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.defaultText,
  },
  popoverToggleInactive: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  popoverToggleInactiveText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.defaultText,
  },
  popoverButton: {
    flexDirection: 'row',
    // justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 44,
    borderBottomStartRadius: 10,
    borderBottomEndRadius: 10,
  },
  popoverButtonText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    color: colors.defaultText,
    marginStart: 10,
  },
  popoverSeparator: {
    height: 1,
    backgroundColor: colors.grey40,
  },
  serviceButton: {
    alignSelf: isTablet() || Platform.OS === 'web' ? 'flex-start' : 'flex-start',
    width: isTablet() || Platform.OS === 'web' ? 154 : 300,
    maxWidth: '43%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 44,
    borderRadius: 4,
    marginBottom: 11,
  },
  buttonText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 15,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 20,
    letterSpacing: 0,
    textAlign: 'center',
  },
  optionButton: {
    // flex: -1,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
  },
  editText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 16,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 22,
    letterSpacing: -0.1,
    color: colors.primary,
  },
  hideKeyboardContainer: {
    alignItems: 'center',
    backgroundColor: colors.accentWhite,
    borderTopWidth: 2,
    borderTopColor: colors.primary,
  },
  hideKeyboardButton: {
    padding: 10,
    flex: 1,
    width: '100%',
  },
  hideKeyboardText: {
    fontFamily: 'FiraSans-SemiBold',
    color: colors.primary,
    fontSize: 18,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    textAlign: 'center',
  },
  generateTextInputHeader: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 12,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 16,
    letterSpacing: 0.2,
    color: colors.grey80,
    marginBottom: 6,
  },
  generateTextInput: {
    width: '100%',
    height: 44,
    backgroundColor: colors.grey30,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.grey40,
    marginBottom: 10,
    paddingHorizontal: 12,
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.defaultText,
    borderRadius: 4,
  },
  generateButtonRed: {
    width: 120,
    height: 44,
    borderRadius: 8,
    backgroundColor: colors.primary,
    alignSelf: 'flex-end',
    marginTop: 18,
    justifyContent: 'center',
    alignItems: 'center',
  },
  generateButtonRedText: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.accentWhite,
    textAlign: 'center',
  },
});

export default DayScreen;
